/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AxiosInstance,
  AxiosRequestConfig,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

export interface QueueInfoDto {
  /** Queue name */
  name: string;
  /** Number of waiting jobs */
  waiting: number;
  /** Number of active jobs */
  active: number;
  /** Number of completed jobs */
  completed: number;
  /** Number of failed jobs */
  failed: number;
  /** Number of delayed jobs */
  delayed: number;
  /** Number of paused jobs */
  paused: number;
}

export interface ListQueueJobsDto {
  /** Array of jobs in the queue */
  jobs: string[];
  /** Total number of jobs */
  total: number;
}

export enum DocumentType {
  Invoice = 'invoice',
  Contract = 'contract',
  LetterOfAuthorization = 'letter-of-authorization',
  Other = 'other',
  SiteList = 'site-list',
}

export interface BulkUpdateDocumentDto {
  documentIds: string[];
  type?: DocumentType | null;
  tags?: string[];
  spendCategory?: string | null;
  vendor?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
}

export enum DocumentStage {
  Uploaded = 'uploaded',
  InProgress = 'in-progress',
  ActionNeeded = 'action-needed',
  Approved = 'approved',
  Rejected = 'rejected',
  Expired = 'expired',
}

export enum DocumentProvidedBy {
  Client = 'client',
  Sib = 'sib',
  Vector = 'vector',
}

export interface PlainExternalUserDto {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
  deletedAt?: string;
}

export interface SpendCategoryListItemDto {
  id: string;
  name: string;
}

export interface DocumentTagDto {
  uuid: string;
  name: string;
  isPredefined?: boolean;
}

export enum DocumentUploadStatus {
  Pending = 'pending',
  Failed = 'failed',
  Uploaded = 'uploaded',
}

export enum ContractType {
  MSA = 'MSA',
  SOW = 'SOW',
  Amendment = 'Amendment',
  Addendum = 'Addendum',
}

export enum CategoryManager {
  ErnestoVidal = 'Ernesto Vidal',
  JorgeDiaz = 'Jorge Diaz',
  KayleePolley = 'Kaylee Polley',
  JenniferNorcross = 'Jennifer Norcross',
  GabriellaDion = 'Gabriella Dion',
  WendyRuggiero = 'Wendy Ruggiero',
  JuanBonilla = 'Juan Bonilla',
  FrankMilatta = 'Frank Milatta',
}

export enum PaymentFrequency {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Annually = 'Annually',
  SemiAnnual = 'Semi-Annual',
}

export interface DocumentDto {
  id: string;
  stage: DocumentStage;
  vendor?: string;
  fileUrl: string;
  fileSize?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  flagged: boolean;
  providedBy: DocumentProvidedBy;
  uploadedBy: PlainExternalUserDto;
  spendCategory?: SpendCategoryListItemDto;
  organizationId: string;
  type?: string;
  tags: DocumentTagDto[];
  uploadStage: DocumentUploadStatus;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format date-time */
  renewalDate?: string;
  annualContractValue?: number;
  notToExceed?: boolean;
  annualPriceIncrease?: boolean;
  earlyTerminationFee?: boolean;
  contractType?: ContractType;
  categoryManager?: CategoryManager;
  paymentFrequency?: PaymentFrequency;
  cancellationDateNoticePeriod?: string;
  autoRenewalClause?: boolean;
  autoRenewalLength?: string;
  notToExceedPercentage?: number;
  anomaly?: boolean;
  matchingDocuments?: number;
  docId?: string;
  docType?: string;
  /** Indicates if the document is a virtual invoice */
  virtual?: boolean;
  originFilename?: string;
  additionalColumns?: object;
}

export interface CreateDocumentDto {
  stage?: DocumentStage;
  vendor?: string | null;
  spendCategory?: string | null;
  type?: DocumentType | null;
  filesize: number;
  filename: string;
  mimetype: string;
  batchId: string;
  totalFiles: number;
  flagged?: boolean;
  startDate?: string;
  endDate?: string;
  renewalDate?: string;
  annualContractValue?: number;
  notToExceed?: boolean;
  annualPriceIncrease?: boolean;
  earlyTerminationFee?: boolean;
  contractType?: ContractType | null;
  categoryManager?: CategoryManager | null;
  paymentFrequency?: PaymentFrequency | null;
  cancellationDateNoticePeriod?: string;
  autoRenewalClause?: boolean;
  autoRenewalLength?: string;
  notToExceedPercentage?: number;
  additionalColumns?: object;
}

export interface GenerateUploadUrlResponseDto {
  id: string;
  stage: DocumentStage;
  vendor?: string;
  fileUrl: string;
  fileSize?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  flagged: boolean;
  providedBy: DocumentProvidedBy;
  uploadedBy: PlainExternalUserDto;
  spendCategory?: SpendCategoryListItemDto;
  organizationId: string;
  type?: string;
  tags: DocumentTagDto[];
  uploadStage: DocumentUploadStatus;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format date-time */
  renewalDate?: string;
  annualContractValue?: number;
  notToExceed?: boolean;
  annualPriceIncrease?: boolean;
  earlyTerminationFee?: boolean;
  contractType?: ContractType;
  categoryManager?: CategoryManager;
  paymentFrequency?: PaymentFrequency;
  cancellationDateNoticePeriod?: string;
  autoRenewalClause?: boolean;
  autoRenewalLength?: string;
  notToExceedPercentage?: number;
  anomaly?: boolean;
  matchingDocuments?: number;
  docId?: string;
  docType?: string;
  /** Indicates if the document is a virtual invoice */
  virtual?: boolean;
  originFilename?: string;
  additionalColumns?: object;
  /**
   * SAS URL to upload the file directly to blob storage
   * @example "https://your-storage.blob.core.windows.net/container/prefix/filename?sv=2024-11-04&spr=https&st=..."
   */
  uploadUrl: string;
}

export interface UploadDocumentDto {
  stage?: DocumentStage;
  vendor?: string | null;
  spendCategory?: string | null;
  type?: DocumentType | null;
  /** Total number of files in the batch upload */
  totalFiles: number;
  flagged?: boolean;
  startDate?: string;
  endDate?: string;
  renewalDate?: string;
  annualContractValue?: number;
  notToExceed?: boolean;
  annualPriceIncrease?: boolean;
  earlyTerminationFee?: boolean;
  contractType?: ContractType | null;
  categoryManager?: CategoryManager | null;
  paymentFrequency?: PaymentFrequency | null;
  cancellationDateNoticePeriod?: string;
  autoRenewalClause?: boolean;
  autoRenewalLength?: string;
  notToExceedPercentage?: number;
  additionalColumns?: object;
  /** This is ID helps us groupd the files in the same bulk upload */
  batchUploadId?: string;
  /**
   * The file to upload
   * @format binary
   */
  file: File;
}

export enum DocumentUploadStage {
  Pending = 'pending',
  Failed = 'failed',
  Uploaded = 'uploaded',
}

export interface PostprocessUploadedDocumentDto {
  status: DocumentUploadStage;
  filename: string;
}

export interface DocumentListDto {
  /** Array of items */
  items: DocumentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateDocumentDto {
  stage?: DocumentStage;
  vendor?: string | null;
  spendCategory?: string | null;
  type?: DocumentType | null;
  flagged?: boolean;
  startDate?: string;
  endDate?: string;
  renewalDate?: string;
  annualContractValue?: number;
  notToExceed?: boolean;
  annualPriceIncrease?: boolean;
  earlyTerminationFee?: boolean;
  contractType?: ContractType | null;
  categoryManager?: CategoryManager | null;
  paymentFrequency?: PaymentFrequency | null;
  cancellationDateNoticePeriod?: string;
  autoRenewalClause?: boolean;
  autoRenewalLength?: string;
  notToExceedPercentage?: number;
  additionalColumns?: object;
  tags?: string[];
  filename?: string;
}

export interface DocumentUploadStatusDto {
  id: string;
  name: string;
  status: DocumentUploadStage;
  createdAt: string;
  updatedAt: string;
}

export interface DocumentUploadStatusListDto {
  /** Array of items */
  items: DocumentUploadStatusDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface SelectListItemDto {
  id: string;
  name: string;
}

export interface SelectListDto {
  items: SelectListItemDto[];
}

export interface ExternalUserPartialListDto {
  /** Array of items */
  items: PlainExternalUserDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export enum UserLoginStatus {
  Uncompleted = 'uncompleted',
  Completed = 'completed',
}

export interface UpdateExternalUserDto {
  contactPhoneNumber?: string;
  firstName?: string;
  surname?: string;
  title?: string;
  contactEmail?: string;
  meetingLink?: string;
  userLoginStatus?: UserLoginStatus;
}

export enum PermissionResource {
  Admin = 'admin',
  Manager = 'manager',
  Employee = 'employee',
  Client = 'client',
  Crm = 'crm',
  Team = 'team',
  Dashboard = 'dashboard',
  Savings = 'savings',
  ActionItems = 'action_items',
  SpendAreas = 'spend_areas',
  Documents = 'documents',
  FlaggedDocuments = 'flagged_documents',
  Locations = 'locations',
  Reports = 'reports',
  Tickets = 'tickets',
  Teams = 'teams',
  Billings = 'billings',
  Vendors = 'vendors',
}

export enum PermissionAction {
  NONE = 0,
  CREATE = 1,
  READ = 2,
  UPDATE = 4,
  DELETE = 8,
}

export interface PermissionDto {
  resource?: PermissionResource;
  action?: PermissionAction;
}

export interface ExternalUserDto {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
  deletedAt?: string;
  surname?: string;
  contactPhoneNumber?: string;
  meetingLink?: string;
  title?: string;
  userLoginStatus?: UserLoginStatus;
}

export interface PowerBiReportDto {
  id: string;
  name?: string;
  groupId: string;
  reportId: string;
  token: string;
  filterQuery?: string;
}

export interface ParentOrganizationDto {
  id: string;
  name: string;
  fileUrl?: string | null;
  width?: number;
  height?: number;
}

export interface OrganizationDto {
  id: string;
  name: string;
  fileUrl?: string | null;
  width?: number;
  height?: number;
  createdAt: string;
  updatedAt: string;
  manager?: ExternalUserDto;
  powerBiReport?: PowerBiReportDto;
  userPermissions?: PermissionDto[];
  permissions?: Record<string, PermissionAction>;
  parentOrganization?: ParentOrganizationDto;
  privateEquityFirm?: ParentOrganizationDto;
  vectorClientId?: string;
  aiEnabled?: boolean;
  aiPort?: string;
  aiBrandingAlias?: string;
  netsuiteCustomerId?: string;
}

export interface YourTeamMemberDto {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
  deletedAt?: string;
  surname?: string;
  contactPhoneNumber?: string;
  meetingLink?: string;
  title?: string;
  userLoginStatus?: UserLoginStatus;
}

export enum BillingInvoiceContactCompany {
  Sib = 'Sib',
  Vector = 'Vector',
}

export interface BillingContactDto {
  id: string;
  name: string;
  email: string;
  contactPhoneNumber: string;
  meetingLink: string;
  title: string;
  provider: BillingInvoiceContactCompany;
}

export interface YourTeamDto {
  primaryContact: YourTeamMemberDto;
  otherSupportingMembers: YourTeamMemberDto[];
  billingContact: BillingContactDto[];
}

export interface SpendCategoryListDto {
  /** Array of items */
  items: SpendCategoryListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface FinancialDetailsDto {
  /**
   * Annual value for the category
   * @example 0
   */
  annual: number;
  /**
   * Monthly value for the category
   * @example 0
   */
  monthly: number;
  /**
   * Total lifetime value for the category
   * @example 0
   */
  totalLifetime: number;
}

export interface SpendCategorySummaryDto {
  /** Spend details for the category */
  spend: FinancialDetailsDto;
  /** Savings approved for the category */
  savingsApproved: FinancialDetailsDto;
  /** Savings identified details for the category */
  savingsIdentified: FinancialDetailsDto;
  /**
   * Percentage saved approved for the category
   * @example 0
   */
  approvedPercentSaved: number;
  /**
   * Percentage saved identified for the category
   * @example 0
   */
  identifiedPercentSaved: number;
}

/** Stage of the spend category */
export enum SpendAreaStage {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  SAVINGS_REALIZED = 'SAVINGS_REALIZED',
  SAVINGS_ESTIMATED = 'SAVINGS_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS = 'NEGOTIATIONS',
}

/** Status of the spend category */
export enum SpendAreaStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  IN_PROGRESS_WITH_SAVINGS = 'IN_PROGRESS_WITH_SAVINGS',
  COMPLETED = 'COMPLETED',
  NOT_ASSIGNED = 'NOT_ASSIGNED',
  REQUESTED = 'REQUESTED',
}

export interface SpendCategoryDto {
  /**
   * Salesforce name for the spend category
   * @example "Waste - Solid / Recycling / Compost"
   */
  salesforceName: string;
  /**
   * Salesforce stage for the spend category
   * @example "Initial Review Performed - Insufficient Opportunity"
   */
  salesforceStage: string;
  /** Summary details for the spend category */
  summary: SpendCategorySummaryDto;
  /**
   * Category name for the spend
   * @example "Waste - Solid / Recycling / Compost"
   */
  name: string;
  /**
   * Stage of the spend category
   * @example "MONITORING_SAVINGS"
   */
  stage: SpendAreaStage;
  /**
   * Status of the spend category
   * @example "IN_PROGRESS"
   */
  status: SpendAreaStatus;
  /** Unique identifier for the spend category */
  id: string;
}

export interface SpendAreaDto {
  /** Unique identifier for the spend area */
  id: string;
  /**
   * Spend area name
   * @example "Waste"
   */
  spendArea: string;
  /**
   * Spend area description
   * @example "This is the most beautiful spend area that your eyes have ever witnessed"
   */
  description: string;
  /** List of spend categories within the spend area */
  spendCategory: SpendCategoryDto[];
  /**
   * Stage of the spend area
   * @example ["MONITORING_SAVINGS"]
   */
  stage: SpendAreaStage[];
  /**
   * Status of the spend area
   * @example "IN_PROGRESS"
   */
  status: SpendAreaStatus;
  /** Summary details for the spend area */
  summary: SpendCategorySummaryDto;
}

export interface SpendAreaResourceDto {
  /** List of spend areas with their spend categories */
  items: SpendAreaDto[];
}

export interface SavingSummaryResponseDto {
  /** Spend details */
  spend: FinancialDetailsDto;
  /** Saving details */
  saving: FinancialDetailsDto;
  /**
   * Percentage of savings
   * @example 3.47
   */
  percentSaved: number;
  /**
   * Indicates if savings are more than a year of expenses
   * @example true
   */
  moreThanYearOfSavings: boolean;
  /**
   * Total number of spending areas
   * @example 16
   */
  spendAreasCount: number;
  /**
   * Number of assigned spending areas
   * @example 15
   */
  assignedSpendAreasCount: number;
}

/** Priority of the task */
export enum PriorityLevel {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export enum TaskCategory {
  VendorCall = 'Vendor Call',
  ClientCall = 'Client Call',
  InternalOutreach = 'Internal outreach',
  VendorEmail = 'Vendor email',
  ClientEmail = 'Client email',
  DataAnalysis = 'Data analysis',
  ReportBuild = 'Report build',
  DataGathering = 'Data gathering',
  InvoiceCollection = 'Invoice Collection',
  Research = 'Research',
  Other = 'Other',
}

export interface TagDto {
  uuid: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  color?: string;
  isPredefined?: boolean;
  createdBy: string;
}

export interface ContactDto {
  id: string;
  name?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  recordTypeName: string;
  phoneNumber?: string;
  serviceProvider?: string;
}

export enum TagType {
  Custom = 'custom',
  Contact = 'contact',
  Employee = 'employee',
}

export interface TaskTagDto {
  tag?: TagDto;
  contact?: ContactDto;
  employee?: ExternalUserDto;
  type?: TagType;
}

export interface BaseTaskOrganizationDto {
  id: string;
  name: string;
  logoUrl?: string | null;
}

export interface TaskRelationDto {
  uuid: string;
  title: string;
}

export interface TaskDto {
  /**
   * Unique identifier for the task
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  uuid: string;
  /**
   * Title of the task
   * @example "Complete project documentation"
   */
  title: string;
  /**
   * Description of the task
   * @example "Finish writing the project documentation by end of the day"
   */
  description?: string | null;
  /**
   * Date when the task was created
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Date when the task was last updated
   * @format date-time
   * @example "2023-01-02T15:30:00Z"
   */
  updatedAt: string;
  /** Priority of the task */
  priorityLevel: PriorityLevel;
  createdByUser: PlainExternalUserDto;
  assigneeUser: PlainExternalUserDto;
  category?: TaskCategory;
  referenceLink?: string;
  referenceName?: string;
  tags: TaskTagDto[];
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  /**
   * Task completion status
   * @example false
   */
  completed: boolean;
  /**
   * Deadline date of the task
   * @format date-time
   * @example "2024-01-02T15:30:00Z"
   */
  deadline: string;
  /**
   * Date of the task completion
   * @format date-time
   * @example "2024-01-02T15:30:00Z"
   */
  completedAt: string;
  unfinishedSubtasksCount: number;
  recurringTaskUuid?: string;
  /** @format date-time */
  seenAt?: string;
  seen?: boolean;
  subauditId?: string;
  organization?: BaseTaskOrganizationDto;
  followUpTask?: TaskRelationDto;
  parentTask?: TaskRelationDto;
  /**
   * Time logged on this task in minutes
   * @min 0
   * @example 120
   */
  timeLogged?: number;
  isDelegated?: boolean;
  projectId?: string;
  commentsCount?: number;
  filesCount?: number;
}

export interface TaskListDto {
  /** Array of items */
  items: TaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  newItemsCount?: number;
}

export interface AllowedDomainListDto {
  items: string[];
}

export interface PlainOrganizationDto {
  id: string;
  name: string;
}

export enum UserType {
  Internal = 'internal',
  External = 'external',
}

export interface InvitedUserDto {
  /**
   * User ID (OID)
   * @example "ad8ff82f-9ab9-4009-8364-513c030c83c8"
   */
  oid: string;
  /**
   * User display name
   * @example "John Doe"
   */
  name: string;
  /**
   * User email
   * @example "john.doe@example.com"
   */
  email: string;
  /**
   * User creation timestamp
   * @example "2025-03-21T06:30:15Z"
   */
  createdDateTime: string;
  userLoginStatus: UserLoginStatus;
  organizations: PlainOrganizationDto[];
  userType: UserType;
}

export enum AdditionalColumnsType {
  Select = 'select',
}

export interface AdditionalColumnValueDto {
  value: string;
  label?: string;
}

export interface AdditionalColumnsDto {
  id: string;
  tableName: string;
  label: string;
  key: string;
  /** @example "select" */
  type: AdditionalColumnsType;
  values?: AdditionalColumnValueDto[];
}

export interface AdditionalColumnsListDto {
  /** List of additional columns */
  items: AdditionalColumnsDto[];
}

export interface CreateTaskTagDto {
  /**
   * ID of the tag (can be either contact ID or tag UUID)
   * @example "a1b2c3d4-e5f6-7890-1234-567890abcdef"
   */
  id: string;
  /**
   * Type of the tag
   * @example "contact"
   */
  type: TagType;
}

export interface CreateTaskDto {
  title: string;
  description?: string;
  priorityLevel?: PriorityLevel;
  category: TaskCategory;
  referenceLink?: string;
  referenceName?: string;
  organizationId?: string;
  /**
   * The ID of the user to assign the task to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  /**
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline: string;
  completed?: boolean;
  seen?: boolean;
  tags?: CreateTaskTagDto[];
  subauditId?: string;
  followUpParentTaskId?: string;
  projectId?: string;
  /**
   * @min 0
   * @example 120
   */
  timeLogged?: number;
}

export interface AssignedUserTaskSummaryDto {
  /** ID of the user the task is assigned to */
  id: string;
  /** Full name of the user the task is assigned to */
  name: string;
  /**
   * Number of tasks created by current user and assigned to this user
   * @example 5
   */
  taskCount: number;
}

export interface AssignedUserTaskSummaryListDto {
  /** Array of items */
  items: AssignedUserTaskSummaryDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface LogTimeDto {
  /**
   * @min 1
   * @example 30
   */
  timeMinutes: number;
}

export interface UpdateTaskDto {
  title?: string;
  description?: string;
  priorityLevel?: PriorityLevel;
  category?: TaskCategory;
  referenceLink?: string;
  referenceName?: string;
  organizationId?: string;
  /**
   * The ID of the user to assign the task to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  completed?: boolean;
  seen?: boolean;
  tags?: CreateTaskTagDto[];
  subauditId?: string;
  followUpParentTaskId?: string;
  projectId?: string;
  /**
   * @min 0
   * @example 120
   */
  timeLogged?: number;
}

export type DeleteResult = object;

export interface ImportTasksDto {
  /**
   * The excel to upload
   * @format binary
   */
  file: File;
}

export enum AuditingAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

/** The type of the entity. Usually the name of the entity. */
export enum ChangelogEntityType {
  Task = 'task',
  Subtask = 'subtask',
  TaskTag = 'taskTag',
  Subaudit = 'subaudit',
}

export enum TaskVersionChangeRecordFields {
  VersionTitle = 'version_title',
  VersionDescription = 'version_description',
  VersionPriorityLevel = 'version_priorityLevel',
  VersionReferenceLink = 'version_referenceLink',
  VersionReferenceName = 'version_referenceName',
  VersionCategory = 'version_category',
  VersionAssignee = 'version_assignee',
  VersionOrganization = 'version_organization',
  VersionCompleted = 'version_completed',
  VersionCompletedAt = 'version_completedAt',
  VersionDeadline = 'version_deadline',
  VersionSeenAt = 'version_seenAt',
  VersionSeen = 'version_seen',
  VersionFollowUpTaskParent = 'version_followUpTaskParent',
  VersionRecurringTask = 'version_recurringTask',
  VersionSubauditId = 'version_subauditId',
  VersionTimeLogged = 'version_timeLogged',
  VersionEstimatedTime = 'version_estimatedTime',
  VersionCreatedBy = 'version_createdBy',
  VersionUpdatedBy = 'version_updatedBy',
  VersionDeletedAt = 'version_deletedAt',
  TagsCreated = 'tags_created',
  TagsDeleted = 'tags_deleted',
}

export interface TaskVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: TaskVersionChangeRecordFields;
}

export interface TaskVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: TaskVersionChangeRecordDto[];
}

export interface TaskVersionChangelogList {
  /** Array of items */
  items: TaskVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export enum SubtaskVersionChangeRecordFields {
  VersionTitle = 'version_title',
  VersionDescription = 'version_description',
  VersionPriorityLevel = 'version_priorityLevel',
  VersionCompleted = 'version_completed',
  VersionCreatedBy = 'version_createdBy',
  VersionTask = 'version_task',
  VersionUpdatedBy = 'version_updatedBy',
}

export interface SubtaskVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: SubtaskVersionChangeRecordFields;
}

export interface SubtaskVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: SubtaskVersionChangeRecordDto[];
}

export interface SubtaskVersionChangelogList {
  /** Array of items */
  items: SubtaskVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export enum TaskTagVersionChangeRecordFields {
  VersionTask = 'version_task',
  VersionRecurringTask = 'version_recurringTask',
  VersionTag = 'version_tag',
  VersionContact = 'version_contact',
  VersionEmployee = 'version_employee',
  VersionType = 'version_type',
  VersionCreatedBy = 'version_createdBy',
  VersionUpdatedBy = 'version_updatedBy',
  VersionDeletedAt = 'version_deletedAt',
}

export interface TaskTagVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: TaskTagVersionChangeRecordFields;
}

export interface TaskTagVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: TaskTagVersionChangeRecordDto[];
}

export interface TaskTagVersionChangelogList {
  /** Array of items */
  items: TaskTagVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface DelegateDto {
  /** Delegate user ID if set */
  id?: string | null;
  /** Delegate user email if set */
  email?: string;
  /** Delegate user name if set */
  fullName?: string;
}

export interface UserSettingsResponseDto {
  /** User ID */
  userId: string;
  /** Delegate settings */
  delegate: DelegateDto;
  /** Additional email address for notifications */
  additionalEmail: string;
}

export interface UpdateUserSettingsDto {
  /**
   * Additional email address for notifications. Set to null to disable.
   * @example "delegate@aboutsib.com"
   */
  additionalEmail?: string | null;
  /** ID of the user to delegate to. Set to null to disable delegation. */
  delegateId?: string | null;
}

export interface CreateSubtaskDto {
  /**
   * Title of the subtask, providing a short summary of what needs to be done
   * @example "Write project documentation"
   */
  title: string;
  /**
   * Detailed description of the subtask, outlining specific requirements or instructions
   * @example "Document all key features and user stories for the project"
   */
  description?: string;
  /**
   * Priority level of the subtask, indicating its importance relative to other tasks
   * @example "high"
   */
  priorityLevel?: PriorityLevel;
  /**
   * UUID of the task to which this subtask belongs, linking it to a parent task
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  taskUuid?: string;
}

export interface SubtaskDto {
  /**
   * Unique identifier for the Subtask
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  uuid: string;
  /**
   * Title of the subtask
   * @example "Complete project documentation"
   */
  title: string;
  /**
   * Description of the subtask
   * @example "Finish writing the project documentation by end of the day"
   */
  description?: string | null;
  /**
   * Subtask completion status
   * @example false
   */
  completed: boolean;
  /**
   * Date when the task was created
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Date when the task was last updated
   * @format date-time
   * @example "2023-01-02T15:30:00Z"
   */
  updatedAt: string;
  /** Priority of the subtask */
  priorityLevel: PriorityLevel;
  taskUuid: string;
}

export interface SubtaskListDto {
  /** Array of items */
  items: SubtaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateSubtaskDto {
  /**
   * Title of the subtask, providing a short summary of what needs to be done
   * @example "Write project documentation"
   */
  title?: string;
  /**
   * Detailed description of the subtask, outlining specific requirements or instructions
   * @example "Document all key features and user stories for the project"
   */
  description?: string;
  /**
   * Priority level of the subtask, indicating its importance relative to other tasks
   * @example "high"
   */
  priorityLevel?: PriorityLevel;
  /** Defines if subtask was finished */
  completed?: boolean;
}

export interface TeamUserDto {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
  deletedAt?: string;
  /** Whether the user can be removed from this team */
  isRemovable?: boolean;
}

export interface TeamDto {
  uuid: string;
  name: string;
  description?: string;
  subtitle?: string;
  activeTaskCount?: number;
  allTaskCount?: number;
  userCount: number;
  createdBy: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  teamLogo?: string;
  /** For list To populate this field you need to pass query parameter "withUsers=true" */
  users?: TeamUserDto[];
  canEdit?: boolean;
}

export interface TeamListDto {
  /** Array of items */
  items: TeamDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TeamMemberDto {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
  deletedAt?: string;
  teamRole: string;
  activeTaskCount: number;
  overdueTaskCount: number;
}

export interface TeamMemberListDto {
  /** Array of items */
  items: TeamMemberDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TeamTaskCountDto {
  dueToday: number;
  overdue: number;
  upcoming: number;
  past: number;
}

export interface UpdateTeamMembersDto {
  userIds: string[];
}

export interface UpdateTeamMembersResponseDto {
  added: string[];
  removed: string[];
  total: number;
}

export interface ContactsListDto {
  /** Array of items */
  items: ContactDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CurrentUserOrganizationDto {
  id: string;
  name: string;
}

export enum EntraGroup {
  Employee = 'employee',
  MicrositeUser = 'microsite-user',
  Cms = 'cms',
}

export interface CurrentUserDto {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
  deletedAt?: string;
  surname?: string;
  contactPhoneNumber?: string;
  meetingLink?: string;
  title?: string;
  userLoginStatus?: UserLoginStatus;
  organizations: CurrentUserOrganizationDto[];
  /** @example "employee" */
  roles: EntraGroup;
}

export interface UserOrganizationsDto {
  id: string;
  name: string;
}

export interface UserOrganizationsListDto {
  /** Array of items */
  items: UserOrganizationsDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface InviteUserBodyDto {
  /** List of emails to invite to the organization */
  emails: string[];
}

export interface InviteUserResponseDto {
  /** List of successfully invited users */
  success: any[][];
  /**
   * List of failed invitations with error messages
   * @example [{"email":"invalid@example.com","error":"Inviting and invited emails must be in the same domain"},{"email":"another@example.com","error":"IDX10612: Decryption failed. Header.Enc is null or empty, it must be specified."}]
   */
  failed: string[];
}

export interface AuditWithSpendAndSavingsDto {
  /**
   * Unique identifier for the audit
   * @example "a09VX000006yT8uYAE"
   */
  id: string;
  /**
   * Audit stage
   * @example "Audit Complete - Finalized Savings"
   */
  auditStage: string;
  /**
   * Audit type
   * @example "Waste - Solid / Recycling / Compost"
   */
  auditType: string;
  /**
   * Annual spend for the audit
   * @example 166381
   */
  auditAnnualSpend: number;
  /**
   * Annual inscope spend for the audit
   * @example 166381
   */
  annualInscopeSpend: number;
  /**
   * Monthly savings identified for the audit
   * @example 2965.56
   */
  monthlySavingsIdentified: number;
  /**
   * Monthly savings approved for the audit
   * @example 2965.56
   */
  monthlySavingsApproved: number;
  /**
   * Annual savings identified for the audit
   * @example 35586.72
   */
  annualSavingsIdentified: number;
  /**
   * Annual savings approved for the audit
   * @example 35586.72
   */
  annualSavingsApproved: number;
  /**
   * Percentage of savings identified against annual spend
   * @example 21.39
   */
  savingsPercentageIdentified: number;
  /**
   * Percentage of savings approved against annual spend
   * @example 21.39
   */
  savingsPercentageApproved: number;
  /**
   * Opportunity count for the audit
   * @example 2
   */
  opportunityCount: number;
  /**
   * Contract length for the audit
   * @example 36
   */
  contractLength: number;
  /**
   * Annual spend analysis complete for the audit
   * @example 166381
   */
  annualSpendAnalysisComplete: number;
  /**
   * Annual spend analysis in progress for the audit
   * @example 0
   */
  annualSpendAnalysisInProgress: number;
  /**
   * Normalized name for the audit type
   * @example "Waste - Solid / Recycling / Compost"
   */
  normalizedName: string;
}

export interface SavingsDto {
  /**
   * Savings value in dollars
   * @example 214943.4
   */
  value: number;
  /**
   * Savings percentage
   * @example 36.97
   */
  percentage: number;
}

export interface SpendAreasSavingsSpendItemTotalsDto {
  /**
   * Annual spend in dollars for the category
   * @example 166381
   */
  annualSpendAnalysisComplete: number;
  /**
   * Spend currently in progress for analysis
   * @example 0
   */
  annualSpendAnalysisInProgress: number;
  /**
   * Spend in scope for the category
   * @example 166381
   */
  inscopeSpend: number;
  /** Savings identified for the category */
  savingsIdentified: SavingsDto;
  /** Savings approved for the category */
  savingsApproved: SavingsDto;
}

export interface SpendAreasSavingsSpendItemDto {
  /**
   * SpendArea name
   * @example "Waste"
   */
  spendArea: string;
  /**
   * Unique identifier for the Spend area
   * @example ""
   */
  id: string;
  /**
   * Description for the Spend Area
   * @example ""
   */
  description: string;
  /** List of audits related to the Spend Area */
  audits: AuditWithSpendAndSavingsDto[];
  /** Total values for the Spend Area */
  totals: SpendAreasSavingsSpendItemTotalsDto;
}

export interface SpendAreasSavingsSpendTotalsDto {
  /**
   * Total annual spend in dollars
   * @example 581414
   */
  annualSpendAnalysisComplete: number;
  /**
   * Total spend currently in progress for analysis
   * @example 5619481
   */
  annualSpendAnalysisInProgress: number;
  /**
   * Total spend in scope
   * @example 6200895
   */
  inscopeSpend: number;
  /** Total savings identified */
  savingsIdentified: SavingsDto;
  /** Total savings approved */
  savingsApproved: SavingsDto;
}

export interface SpendAreasSavingsSpendResponseDto {
  /** List of spend areas with their audit details */
  spendAreas: SpendAreasSavingsSpendItemDto[];
  /** Aggregated totals for all spend areas */
  totals: SpendAreasSavingsSpendTotalsDto;
}

export interface TotalSavingsDto {
  /**
   * Annual savings value in dollars
   * @example 2559.12
   */
  annualSaving: number;
  /**
   * Monthly savings value in dollars
   * @example 213
   */
  monthlySaving: number;
  /**
   * Savings percentage
   * @example 1.42
   */
  percentage: number;
}

export interface AnnualSavingsDto {
  /**
   * Annual savings value in dollars
   * @example 2559.12
   */
  value: number;
  /**
   * Savings percentage
   * @example 100
   */
  percentage: number;
}

export interface AnnualSavingsForSpendAreaSpendCategoryDto {
  /**
   * Spend category name
   * @example "Maintenance - Elevator / Escalator"
   */
  name: string;
  /** Annual savings details for the category */
  annualSavings: AnnualSavingsDto;
}

export interface SpendAndAnalysisSpendAreaDto {
  /**
   * Spend area name
   * @example "Maintenance"
   */
  name: string;
  /**
   * Flag indicating if savings are made in this area
   * @example true
   */
  areSavingsMade: boolean;
  /** Total savings details for the spend area */
  totalSavings: TotalSavingsDto;
  /** List of spend categories within this spend area */
  spendCategories: AnnualSavingsForSpendAreaSpendCategoryDto[];
}

export interface AnnualSavingsForSpendAreaResponseDto {
  /** List of spend areas and their details */
  items: SpendAndAnalysisSpendAreaDto[];
}

export interface TicketFileDto {
  id: string;
  fileName: string;
  fileType?: string;
  fileUrl: string;
  showInDocumentsRepo: boolean;
  fileSize?: number;
}

export interface TicketFileListDto {
  /** Array of items */
  items: TicketFileDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export enum NotificationPriority {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

export interface NotificationDto {
  uuid: string;
  title: string;
  description?: string;
  type: string;
  priority: NotificationPriority;
  /** @format date-time */
  seenAt: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  actionMetadata: any;
}

export interface NotificationListDto {
  /** Array of items */
  items: NotificationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  newItemsCount?: number;
}

export interface UpdateNotificationDto {
  seen?: boolean;
}

export interface NotificationCountDto {
  count: number;
}

export enum RecurrenceInterval {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

export interface CreateRecurringTaskDto {
  title: string;
  description?: string;
  priorityLevel?: PriorityLevel;
  category: TaskCategory;
  referenceLink?: string;
  referenceName?: string;
  organizationId?: string;
  /**
   * The ID of the user to assign the task to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  timeToComplete: RecurrenceInterval;
  timeToCompleteAmount: number;
  /**
   * Start date for the recurring task
   * @format date-time
   */
  repeatStartDate?: string;
  /**
   * End date for the recurring task
   * @format date-time
   */
  repeatEndDate?: string;
  /** Recurrence interval - day, week, month */
  repeatInterval?: RecurrenceInterval;
  /** Interval amount for the recurrence */
  repeatIntervalAmount?: number;
  /** Days of the week for the recurrence (1-5) */
  repeatOnWeekDays?: number[];
  /** Day of the month for the recurrence (1-31) */
  repeatOnMonthDay?: number;
  /** Weekday order for the recurrence (1-5) */
  repeatOnMonthWeekdayOrder?: number;
  /** Weekday for the recurrence (1-5) */
  repeatOnMonthWeekdayDay?: number;
  tags?: CreateTaskTagDto[];
}

export interface RecurringTaskDto {
  /**
   * Unique identifier for the task
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  uuid: string;
  /**
   * Title of the task
   * @example "Complete project documentation"
   */
  title: string;
  /**
   * Description of the task
   * @example "Finish writing the project documentation by end of the day"
   */
  description?: string | null;
  /**
   * Date when the task was created
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Date when the task was last updated
   * @format date-time
   * @example "2023-01-02T15:30:00Z"
   */
  updatedAt: string;
  /** Priority of the task */
  priorityLevel: PriorityLevel;
  createdByUser: PlainExternalUserDto;
  assigneeUser: PlainExternalUserDto;
  category?: TaskCategory;
  referenceLink?: string;
  referenceName?: string;
  tags: TaskTagDto[];
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  timeToComplete: RecurrenceInterval;
  timeToCompleteAmount: number;
  /**
   * Start date for the recurring task
   * @format date-time
   */
  repeatStartDate?: string;
  /**
   * End date for the recurring task
   * @format date-time
   */
  repeatEndDate?: string;
  /** Recurrence interval - day, week, month */
  repeatInterval?: RecurrenceInterval;
  /** Interval amount for the recurrence */
  repeatIntervalAmount?: number;
  /** Days of the week for the recurrence (1-5) */
  repeatOnWeekDays?: number[];
  /** Day of the month for the recurrence (1-31) */
  repeatOnMonthDay?: number;
  /** Weekday order for the recurrence (1-5) */
  repeatOnMonthWeekdayOrder?: number;
  /** Weekday for the recurrence (1-5) */
  repeatOnMonthWeekdayDay?: number;
}

export interface RecurringTaskListDto {
  /** Array of items */
  items: RecurringTaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateRecurringTaskDto {
  title?: string;
  description?: string;
  priorityLevel?: PriorityLevel;
  category?: TaskCategory;
  referenceLink?: string;
  referenceName?: string;
  organizationId?: string;
  /**
   * The ID of the user to assign the task to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  timeToComplete?: RecurrenceInterval;
  timeToCompleteAmount?: number;
  /**
   * Start date for the recurring task
   * @format date-time
   */
  repeatStartDate?: string;
  /**
   * End date for the recurring task
   * @format date-time
   */
  repeatEndDate?: string;
  /** Recurrence interval - day, week, month */
  repeatInterval?: RecurrenceInterval;
  /** Interval amount for the recurrence */
  repeatIntervalAmount?: number;
  /** Days of the week for the recurrence (1-5) */
  repeatOnWeekDays?: number[];
  /** Day of the month for the recurrence (1-31) */
  repeatOnMonthDay?: number;
  /** Weekday order for the recurrence (1-5) */
  repeatOnMonthWeekdayOrder?: number;
  /** Weekday for the recurrence (1-5) */
  repeatOnMonthWeekdayDay?: number;
  tags?: CreateTaskTagDto[];
}

export interface OrganizationMemberDto {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
  deletedAt?: string;
  /** @example "3" */
  taskCount?: number;
}

export interface MemberListDto {
  /** Array of items */
  items: OrganizationMemberDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export enum OrganizationSpecialFilter {
  Membership = 'membership',
  ActiveTasks = 'active-tasks',
}

export interface OrganizationSummaryWithCountsDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  /** @example 5 */
  membersCount: number;
  /** @example 3 */
  activeTasksCount: number;
}

export interface OrganizationSummaryWithCountsListDto {
  /** Array of items */
  items: OrganizationSummaryWithCountsDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationSummaryWithMyActiveTasksCountDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  /** @example 5 */
  myActiveTasksCount: number;
}

export interface OrganizationSummaryWithMyActiveTasksCountListDto {
  /** Array of items */
  items: OrganizationSummaryWithMyActiveTasksCountDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationSummaryWithActionItemsCountDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  /** @example 5 */
  actionItems: number;
}

export interface OrganizationSummaryWithActionItemsCountListDto {
  /** Array of items */
  items: OrganizationSummaryWithActionItemsCountDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  /** @example 100 */
  allActionItems: number;
  /** @example 40 */
  myOrganizationsActionItems: number;
}

export interface TaskCommentDto {
  id: string;
  comment: string;
  taskId: string;
  createdBy: PlainExternalUserDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface TaskCommentListDto {
  /** Array of items */
  items: TaskCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateTaskCommentDto {
  comment: string;
}

export interface AuditDto {
  id: string;
  name: string;
  type: string;
  stage: string;
}

export interface LocationSelectListItemDto {
  id: string;
  name: string;
}

export enum SubauditStage {
  New = 'New',
  GatherInfoVendor = 'Gather Info - Vendor',
  NegotiationInProgress = 'Negotiation In Progress',
  NegotiationCompleted = 'Negotiation Completed',
}

export interface TeamReferenceDto {
  uuid: string;
  name: string;
  photoUrl: string;
}

export interface SubauditDto {
  id: string;
  onHold: boolean;
  subauditName: string;
  autoIncrementedId: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  audit: AuditDto;
  owner: PlainExternalUserDto;
  organization: OrganizationDto;
  location: LocationSelectListItemDto;
  spendArea: string;
  vendor: OrganizationDto;
  vendorAccountIdentifier: string;
  spendAmount: number;
  subAuditStage: SubauditStage;
  team: TeamReferenceDto;
}

export interface SubauditsListDto {
  /** Array of items */
  items: SubauditDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSubauditDto {
  onHold?: boolean;
  subauditName: string;
  auditId: string;
  ownerId: string;
  vendorId: string;
  locationId: string;
  vendorAccountNumber: string;
  spendAmount: number;
  subauditStage: SubauditStage;
  teamId: string;
}

export interface UpdateSubauditDto {
  onHold?: boolean;
  subauditName?: string;
  auditId?: string;
  ownerId?: string;
  vendorId?: string;
  locationId?: string;
  vendorAccountNumber?: string;
  spendAmount?: number;
  subauditStage?: SubauditStage;
  teamId?: string;
}

export interface AuditsListDto {
  /** Array of items */
  items: AuditDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface SubauditCommentDto {
  id: string;
  content: string;
  topic: string;
  subauditId: string;
  createdBy: PlainExternalUserDto;
  createdAt: string;
}

export interface SubauditCommentListDto {
  /** Array of items */
  items: SubauditCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSubauditCommentDto {
  topic: string;
  content: string;
}

export interface UpdateSubauditCommentDto {
  topic?: string;
  content?: string;
}

export enum SubauditVersionChangeRecordFields {
  VersionAuditId = 'version_auditId',
  VersionOwner = 'version_owner',
  VersionOrganization = 'version_organization',
  VersionVendor = 'version_vendor',
  VersionVendorAccountNumber = 'version_vendorAccountNumber',
  VersionSpendAmount = 'version_spendAmount',
  VersionSubauditStage = 'version_subauditStage',
  VersionUpdatedBy = 'version_updatedBy',
  VersionCreatedBy = 'version_createdBy',
  VersionTeam = 'version_team',
  VersionLocation = 'version_location',
  VersionSubauditName = 'version_subauditName',
  VersionAutoIncrementedId = 'version_autoIncrementedId',
  VersionOnHold = 'version_onHold',
}

export interface SubauditVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: SubauditVersionChangeRecordFields;
}

export interface SubauditVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: SubauditVersionChangeRecordDto[];
}

export interface SubauditVersionChangelogList {
  /** Array of items */
  items: SubauditVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

/** Type of the action, indicating file upload. */
export enum ActionItemType {
  MeetingLink = 'meeting-link',
  Link = 'link',
  FileUpload = 'file-upload',
}

export interface FileUploadActionTypeDto {
  /**
   * Type of the action, indicating file upload.
   * @example "file-upload"
   */
  type: ActionItemType;
  /**
   * Public URL to the uploaded file
   * @example "/api/document/file/001XYZ_file.png"
   */
  url: string;
  /**
   * Original filename of the uploaded document
   * @example "001XYZ_file.png"
   */
  filename: string;
  id: string;
}

export interface PutFileUploadActionTypeDto {
  /** @example "file-upload" */
  type: ActionItemType;
}

export interface MeetingLinkActionTypeDto {
  /** @example "meeting-link" */
  type: ActionItemType;
  /** Meeting link URL. */
  url: string;
  /**
   * Date of the meeting.
   * @format date-time
   */
  date: string;
}

export interface LinkActionTypeDto {
  /** @example "link" */
  type: ActionItemType;
  url: string;
}

export interface ActionItemDto {
  id: string;
  title: string;
  description?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deadline: string;
  /** @format date-time */
  completedAt?: string;
  spendAreaStage: SpendAreaStage;
  organization: PlainOrganizationDto;
  priorityLevel: PriorityLevel;
  actionType: ActionItemType;
  /** Action details associated with the step. */
  actionDetails:
    | MeetingLinkActionTypeDto
    | FileUploadActionTypeDto
    | LinkActionTypeDto;
  createdBy: PlainExternalUserDto;
  assignee: PlainExternalUserDto;
  notifyExternalClient: boolean;
}

export interface ActionItemListDto {
  /** Array of items */
  items: ActionItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateActionItemDto {
  title: string;
  description?: string;
  /**
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline?: string;
  /** @example "MOBILIZATION" */
  spendAreaStage: SpendAreaStage;
  /** @example "high" */
  priorityLevel: PriorityLevel;
  assignee?: string | null;
  projectId?: string;
  /**
   * Action details associated with the step. Must be a valid JSON string in multipart/form-data.
   *
   * file-upload type:
   * {"type": "file-upload"}
   *
   * meeting-link type:
   * {
   * "type": "meeting-link",
   * "url": "https://meet.google.com/example",
   * "date": "2025-03-11T17:46:33.200Z"
   * }
   * @example "{"type": "file-upload"}"
   */
  action?:
    | MeetingLinkActionTypeDto
    | PutFileUploadActionTypeDto
    | LinkActionTypeDto
    | null;
  /**
   * File to upload (only required if action.type = file-upload)
   * @format binary
   */
  file?: File;
  /**
   * Send notification email to external client when assigned
   * @default false
   */
  notifyExternalClient?: boolean;
}

export interface UpdateActionItemDto {
  title?: string;
  description?: string;
  /**
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline?: string;
  /** @example "MOBILIZATION" */
  spendAreaStage?: SpendAreaStage;
  /** @example "high" */
  priorityLevel?: PriorityLevel;
  assignee?: string | null;
  projectId?: string;
  /**
   * Action details associated with the step. Must be a valid JSON string in multipart/form-data.
   *
   * file-upload type:
   * {"type": "file-upload"}
   *
   * meeting-link type:
   * {
   * "type": "meeting-link",
   * "url": "https://meet.google.com/example",
   * "date": "2025-03-11T17:46:33.200Z"
   * }
   * @example "{"type": "file-upload"}"
   */
  action?:
    | MeetingLinkActionTypeDto
    | PutFileUploadActionTypeDto
    | LinkActionTypeDto
    | null;
  /**
   * File to upload (only required if action.type = file-upload)
   * @format binary
   */
  file?: File;
  /**
   * Send notification email to external client when assigned
   * @default false
   */
  notifyExternalClient?: boolean;
  completed?: boolean;
}

export interface CreateProjectDto {
  name: string;
  teamId: string;
  projectStatus?: CreateProjectDtoProjectStatusEnum;
  startDate?: string;
  targetEndDate?: string;
  assigneeId?: string;
}

export enum ProjectStatus {
  Active = 'active',
  Archived = 'archived',
  OnHold = 'on-hold',
}

export interface PlainTeamDto {
  id: string;
  name: string;
}

export interface ProjectDto {
  id: string;
  name: string;
  projectStatus: ProjectStatus;
  team: PlainTeamDto;
  owner: PlainExternalUserDto;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  targetEndDate?: string;
  assignee?: PlainExternalUserDto;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  createdAt: string;
}

export interface ProjectInTeamSummaryDto {
  id: string;
  name: string;
  projectStatus: ProjectStatus;
  owner: PlainExternalUserDto;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  targetEndDate?: string;
}

export interface TeamWithProjectsDto {
  id: string;
  name: string;
  projectsCount: number;
  projects: ProjectInTeamSummaryDto[];
}

export interface TeamWithProjectsListDto {
  items: TeamWithProjectsDto[];
}

export interface UpdateProjectDto {
  name?: string;
  teamId?: string;
  projectStatus?: UpdateProjectDtoProjectStatusEnum;
  startDate?: string;
  targetEndDate?: string;
  assigneeId?: string;
  ownerId?: string;
}

export interface LocationDto {
  id: string;
  dba: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  taxId: string;
  fullLegalName: string;
  /** The status of the location */
  status: LocationDtoStatusEnum;
  spendArea: string;
  /** List of stages associated with the location */
  spendAreaStage: LocationDtoSpendAreaStageEnum[];
  savingsApproved?: number;
  spendApproved?: number;
  /** Additional information as key-value pairs */
  additionalInfo?: object;
  /** Status of the document field */
  documentFieldStatus?: LocationDtoDocumentFieldStatusEnum;
  locationIdentifier: string;
  salesforceId: string;
  requestedChange?: LocationDtoRequestedChangeEnum;
}

export interface LocationListDto {
  /** Array of items */
  items: LocationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface FileMetadataDto {
  /**
   * Unique ID of the uploaded file
   * @example "file_abc123"
   */
  id: string;
  /**
   * Original name of the uploaded file
   * @example "site-list.xlsx"
   */
  filename: string;
  /**
   * Signed URL to access the uploaded file
   * @example "https://s3.bucket.com/documents/site-list.xlsx?..."
   */
  url: string;
  /**
   * Timestamp when the file was uploaded
   * @example "2025-06-05T10:20:30.000Z"
   */
  uploadedAt?: string;
}

export interface GetFilesUnderValidationResponseDto {
  /** Array of unique uploaded files under validation */
  items: FileMetadataDto[];
  /** Most recently uploaded file, or an empty object if none found */
  lastUploadedFile?: FileMetadataDto;
}

export interface ExcelUploadResponseDto {
  /**
   * Informacja, czy plik Excel pochodzi ze standardowego szablonu
   * @example true
   */
  isExcelFileFromTemplate: boolean;
  /** Uploaded file URL */
  fileUrl: string;
  /**
   * List of created location UUIDs
   * @example ["550e8400-e29b-41d4-a716-446655440000"]
   */
  createdLocationIds: string[];
}

export interface LocationActionBodyDto {
  /**
   * The type of action to perform on the locations
   * @example "exclude_from_audit"
   */
  actionType: LocationActionBodyDtoActionTypeEnum;
  /**
   * Array of location IDs to apply the action to
   * @example ["location_1","location_2","location_3"]
   */
  locationIds: string[];
}

export interface LocationActionResponseDto {
  /**
   * Confirmation message for the action request
   * @example "Change request created successfully"
   */
  message: string;
  /**
   * Array of location IDs that were processed
   * @example ["location_1","location_2"]
   */
  updatedLocations: string[];
}

export interface UpdateLocationDto {
  dba?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  taxId?: string;
  legalName?: string;
  status?: UpdateLocationDtoStatusEnum;
  spendArea?: string;
  /** List of stages associated with the location */
  spendAreaStage?: UpdateLocationDtoSpendAreaStageEnum[];
  /** Additional information as key-value pairs */
  additionalInfo?: object;
  documentFieldStatus?: UpdateLocationDtoDocumentFieldStatusEnum;
  locationIdentifier?: string;
  /** The requested change action, can be one of LocationAction values or an empty string */
  requestedChange?: UpdateLocationDtoRequestedChangeEnum;
}

export interface TemplateActionItemFileDto {
  filename: string;
  url: string;
  size: number;
  mimeType: string;
}

export interface TemplateActionItemDto {
  id: string;
  title: string;
  description?: string;
  spendAreaStage: SpendAreaStage;
  priorityLevel: PriorityLevel;
  actionType?: ActionItemType;
  /** @format date-time */
  dueDate?: string;
  link?: string;
  dueDateInDays?: number;
  file?: TemplateActionItemFileDto;
}

export interface ActionItemTemplateDto {
  id: string;
  name: string;
  description?: string;
  actionItems: TemplateActionItemDto[];
}

export interface ActionItemTemplateListDto {
  /** Array of items */
  items: ActionItemTemplateDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface RequestSpendAreaResponseDto {
  /** Ids of "requested spend areas" */
  createdRequestSpendAreasIds: string[];
  /** List of "spend areas" that were created */
  createdSpendAreasIds: string[];
  /** List of spend areas that were not created */
  skippedSpendAreasIds: string[];
}

export interface RequestSpendAreaBodyDto {
  spendAreaIds: string[];
}

export interface PowerBiReportListItemDto {
  id: string;
  name?: string;
  groupId: string;
  reportId: string;
}

export interface PowerBiReportListDto {
  /** Array of items */
  items: PowerBiReportListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ChildOrganizationDto {
  id: string;
  name: string;
  savingsApproved: number;
  savingsIdentified: number;
  inScopeSpend: number;
}

export interface ChildOrganizationListDto {
  /** Array of items */
  items: ChildOrganizationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export enum TicketStatus {
  InProgress = 'in_progress',
  New = 'new',
  Closed = 'closed',
  WorkingWithVendor = 'working_with_vendor',
  AwaitingClientAction = 'awaiting_client_action',
  AwaitingInternalAction = 'awaiting_internal_action',
  Canceled = 'canceled',
  Completed = 'completed',
}

export enum TicketCategory {
  Account = 'account',
  Baselines = 'baselines',
  Client = 'client',
  Contract = 'contract',
  CustomerService = 'customer_service',
  Escalation = 'escalation',
  Exceptions = 'exceptions',
  Finance = 'finance',
  FollowUp = 'follow_up',
  InformationRequest = 'information_request',
  Invoice = 'invoice',
  MasterData = 'master_data',
  Negotiation = 'negotiation',
  Others = 'others',
  Payments = 'payments',
  Property = 'property',
  ServiceRequest = 'service_request',
  Transitions = 'transitions',
  VendorLocal = 'vendor_local',
  MissingBill = 'missing_bill',
  UpdateMailingAddress = 'update_mailing_address',
  PotentialLeak = 'potential_leak',
  InvoiceQuestion = 'invoice_question',
}

export interface TicketDto {
  id: string;
  vectorTicketId?: number;
  clientId: string;
  subject: string;
  description?: string;
  status?: TicketStatus;
  priority?: PriorityLevel;
  category?: TicketCategory;
  vendorName?: string;
  location?: string;
  requestor?: PlainExternalUserDto;
  assignee?: PlainExternalUserDto;
  /** @format date-time */
  dueDate?: string;
  /** @format date-time */
  followUpDate?: string;
  contractVersion?: string;
  accessToExternalUser?: boolean;
  locationId?: string;
  locationName?: string;
  zip?: string;
  state?: string;
  address?: string;
  city?: string;
  subStatus?: string;
  updatedBy?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt: string;
  receiveEmailNotifications?: boolean;
  organization?: PlainOrganizationDto;
  participants?: PlainExternalUserDto[];
  savingsAmount?: number;
}

export interface TicketListDto {
  /** Array of items */
  items: TicketDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateTicketDto {
  /** @maxLength 256 */
  subject?: string;
  /** @maxLength 1024 */
  description?: string;
  status?: TicketStatus;
  priority?: PriorityLevel;
  category?: TicketCategory;
  /**
   * Supported formats: image/jpeg, image/png, image/webp, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf, text/csv, text/plain, message/rfc822, application/vnd.ms-outlook, application/octet-stream, video/webm, video/mp4, audio/mpeg files. Max size: 200MB. Max count: 10 files.
   * @maxItems 10
   */
  files?: File[];
  /**
   * Show in Documents Repository for each file (must match files array length)
   * @maxItems 10
   */
  showInDocumentsRepo?: boolean[];
  receiveEmailNotifications?: boolean;
  /** If true, ticket is external (accessible to clients). If false, ticket is internal. */
  accessToExternalUser?: boolean;
  assigneeId?: string;
  projectId?: string;
  /** Array of user IDs to set as participants */
  participantIds?: string[];
  /**
   * Savings amount (only visible when category is Finance, Invoice, or Payments). For non-vector tickets only.
   * @min 0
   */
  savingsAmount?: number;
  /** Array of file IDs to remove from the ticket */
  filesToDelete?: string[];
  /** IDs of files to move FROM the ticket TO the Documents Repository */
  filesToMoveToDocumentsRepo?: string[];
  /** IDs of files to remove FROM the Documents Repository back TO the ticket */
  filesToRemoveFromDocumentsRepo?: string[];
}

export enum TicketCommentScope {
  Internal = 'internal',
  External = 'external',
}

export interface CreateTicketCommentDto {
  text: string;
  /** @default "external" */
  scope: TicketCommentScope;
  /** List of external users IDs to notify */
  notifyUsers: string[];
}

export interface TicketCommentDto {
  id: string;
  source: string;
  comment: string;
  /** @default "external" */
  scope?: TicketCommentScope;
  createdBy: PlainExternalUserDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface TicketCommentListDto {
  /** Array of items */
  items: TicketCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface InvoiceSummaryDto {
  thirtyDays: number;
  sixtyDays: number;
  ninetyDays: number;
  overNinetyDays: number;
  total: number;
  totalUnpaidInvoices: number;
}

export enum InvoicePaymentStatus {
  Paid = 'paid',
  Unpaid = 'unpaid',
  PartiallyPaid = 'partially-paid',
}

export interface InvoiceFileDto {
  id: string;
  name: string;
  url: string;
  fileSize: number;
  messageDate: string;
}

export interface NetsuiteInvoiceDto {
  id: string;
  date: string;
  dueDate: string;
  amount: number;
  balance: number;
  status: InvoicePaymentStatus;
  /** Link to the main PDF file of the invoice */
  fileUrl: string;
  internalId: string;
  paymentUrl: string;
  /** Additional files associated with the netsuite invoice */
  files: InvoiceFileDto[];
}

export interface NetsuiteInvoiceListDto {
  /** Array of items */
  items: NetsuiteInvoiceDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VectorInvoiceDto {
  id: string;
  date: string;
  dueDate: string;
  amount: number;
  balance: number;
  status: InvoicePaymentStatus;
  /** Link to the main PDF file of the invoice */
  fileUrl: string;
  vendorName: string;
  locationId: number;
  locationName: string;
  accountNumber: string;
}

export interface VectorInvoiceListResponseDto {
  /** Array of items */
  items: VectorInvoiceDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateZipNetsuiteRequestDto {
  /** Array of invoice IDs to include in the ZIP archive */
  invoiceIds: string[];
}

export interface FailedDownloadDocumentDto {
  url: string;
  name: string;
}

export interface CreateBillingsZipResponseDto {
  sasUrl: string;
  failedDownloads: FailedDownloadDocumentDto[];
  successDownloadsCount: number;
}

export type StreamableFile = object;

export interface CreateZipVectorRequestDto {
  /** Array of invoice download urls take from vector api to include in the ZIP archive */
  downloadUrls: string[];
}

export interface FaqCategoryDto {
  id: string;
  name: string;
  description?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface FaqIconDto {
  id: string;
  url: string;
  alt?: string;
  filename: string;
  mimeType: string;
  filesize: number;
  width?: number;
  height?: number;
}

export interface FaqFileDto {
  id: string;
  fileName: string;
  fileType?: string;
  url: string;
}

export interface FaqDto {
  id: string;
  title: string;
  description: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** FAQ category information */
  category: FaqCategoryDto;
  /** FAQ icon/image */
  icon?: FaqIconDto;
  /** FAQ file attachment (PDF) */
  file?: FaqFileDto;
}

export interface FaqListDto {
  /** Array of items */
  items: FaqDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export enum DevicePlatform {
  Ios = 'ios',
  Android = 'android',
  Web = 'web',
}

export interface RegisterDeviceTokenDto {
  /**
   * @maxLength 512
   * @example "fMwqR9p0TXa..."
   */
  token: string;
  /** @example "ios" */
  platform: DevicePlatform;
  /**
   * @maxLength 512
   * @example "iPhone 15 Pro"
   */
  deviceName?: string;
}

export interface DeviceTokenDto {
  id: string;
  /** @example "ios" */
  platform: DevicePlatform;
  deviceName?: string;
  isActive: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  lastUsedAt?: string;
}

export interface UnregisterTokenDto {
  message: string;
}

export interface DeviceTokensListDto {
  /** Array of items */
  items: DeviceTokenDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

/** Difficulty level */
export enum Difficulty {
  VeryEasy = 'VeryEasy',
  Easy = 'Easy',
  Neutral = 'Neutral',
  Hard = 'Hard',
  VeryHard = 'VeryHard',
}

export interface CreateReviewDto {
  /**
   * Difficulty level
   * @example "Neutral"
   */
  gettingStarted: Difficulty;
  /**
   * Difficulty level
   * @example "VeryEasy"
   */
  navigationEase: Difficulty;
  improvementSuggestion?: string;
}

export interface TagsListDto {
  /** Array of items */
  items: TagDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateTagDto {
  name: string;
  /**
   * Hexadecimal color value (e.g., #FF0000, #f00)
   * @example "#FF0000"
   */
  color?: string;
  isPredefined?: boolean;
}

export interface UpdateTagDto {
  name?: string;
  /**
   * Hexadecimal color value (e.g., #FF0000, #f00)
   * @example "#FF0000"
   */
  color?: string;
  isPredefined?: boolean;
}

export interface VendorSelectListItemDto {
  id: string;
  name: string;
}

export interface VendorSelectListDto {
  items: VendorSelectListItemDto[];
}

export interface ServiceCategoryDto {
  id: string;
  categoryName: string;
}

export interface VendorDto {
  id: string;
  salesforceId: string;
  vendorName: string;
  recordType: string;
  serviceCategory?: ServiceCategoryDto;
  pointOfContact?: string;
  pointOfContactDetails?: ContactDto;
  subauditId: string;
  contractsCount?: number;
  vectorVendorId?: number;
}

export interface VendorsListDto {
  /** Array of items */
  items: VendorDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpsertPreferenceBodyDto {
  /**
   * Any valid JSON value to be stored (string, number, boolean, array, object, null)
   * @example ["org1","org2"]
   */
  value: string | number | boolean | any[] | object | null;
}

export interface PreferenceDto {
  /** @example "user" */
  type: PreferenceDtoTypeEnum;
  userId?: string;
  organizationId?: string;
  key: string;
  /** @example {"columns":["id","name","created"]} */
  value: string | number | boolean | any[] | object | null;
}

export interface PreferenceListDto {
  /** List of preferences */
  items: PreferenceDto[];
}

export interface LocationSelectListDto {
  /** Array of items */
  items: LocationSelectListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface DocumentTagsListDto {
  /** Array of items */
  items: DocumentTagDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateDocumentTagDto {
  name: string;
  color?: string;
}

export interface UpdateDocumentTagDto {
  name?: string;
  color?: string;
}

export interface CreateArchiveDocumentsRequestDto {
  /**
   * Array of document IDs to include in the ZIP archive
   * @example ["550e8400-e29b-41d4-a716-446655440000","550e8400-e29b-41d4-a716-446655440001"]
   */
  documentIds: string[];
}

export interface ArchiveDocumentsResponseDto {
  sasUrl: string;
  failedDownloads: FailedDownloadDocumentDto[];
  successDownloadsCount: number;
}

export interface VectorLocationDto {
  id: number;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  status: string;
  savings: number;
  autoPay: boolean;
  ledgerNo: string;
  cost: number;
}

export interface VectorLocationListDto {
  /** Array of items */
  items: VectorLocationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export enum VectorApiContractStatus {
  Archived = 'Archived',
  FullyExecuted = 'Fully Executed',
  BillProcessingOnly = 'Bill Processing Only',
}

export interface VectorContractDto {
  id: string;
  negotiationNo: string;
  locationName: string;
  vendorName: string;
  status: VectorApiContractStatus;
  /** @format date-time */
  effectiveDate: string;
  isVetted: boolean;
  fileUrl: string;
}

export interface VectorContractsListDto {
  /** Array of items */
  items: VectorContractDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateProfilePictureDto {
  /** @format binary */
  file: File;
}

export interface CreateTicketDto {
  /** @maxLength 256 */
  subject: string;
  /** @maxLength 1024 */
  description?: string;
  status?: TicketStatus;
  priority?: PriorityLevel;
  category?: TicketCategory;
  /**
   * Supported formats: image/jpeg, image/png, image/webp, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf, text/csv, text/plain, message/rfc822, application/vnd.ms-outlook, application/octet-stream, video/webm, video/mp4, audio/mpeg files. Max size: 200MB. Max count: 10 files.
   * @maxItems 10
   */
  files?: File[];
  /**
   * Show in Documents Repository for each file (must match files array length)
   * @maxItems 10
   */
  showInDocumentsRepo?: boolean[];
  receiveEmailNotifications?: boolean;
  /** If true, ticket is external (accessible to clients). If false, ticket is internal. */
  accessToExternalUser?: boolean;
  assigneeId?: string;
  projectId?: string;
  /** Array of user IDs to set as participants */
  participantIds?: string[];
  /**
   * Savings amount (only visible when category is Finance, Invoice, or Payments). For non-vector tickets only.
   * @min 0
   */
  savingsAmount?: number;
}

export interface TicketWithDetailsDto {
  id: string;
  vectorTicketId?: number;
  clientId: string;
  subject: string;
  description?: string;
  status?: TicketStatus;
  priority?: PriorityLevel;
  category?: TicketCategory;
  vendorName?: string;
  location?: string;
  requestor?: PlainExternalUserDto;
  assignee?: PlainExternalUserDto;
  /** @format date-time */
  dueDate?: string;
  /** @format date-time */
  followUpDate?: string;
  contractVersion?: string;
  accessToExternalUser?: boolean;
  locationId?: string;
  locationName?: string;
  zip?: string;
  state?: string;
  address?: string;
  city?: string;
  subStatus?: string;
  updatedBy?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt: string;
  receiveEmailNotifications?: boolean;
  organization?: PlainOrganizationDto;
  participants?: PlainExternalUserDto[];
  savingsAmount?: number;
  documents?: TicketFileDto[];
  comments?: TicketCommentDto[];
}

export interface CreateTicketCommentExternalDto {
  text: string;
  /** List of external users IDs to notify */
  notifyUsers: string[];
}

export interface CreateTicketCommentResponseDto {
  message: string;
}

export interface OrganizationTicketCountDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  ticketCount: number;
}

export interface OrganizationTicketCountListDto {
  items: OrganizationTicketCountDto[];
}

export interface AssigneeTicketGroupingDto {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
  deletedAt?: string;
  ticketCount: number;
}

export interface AssigneeTicketGroupingListDto {
  /** Array of items */
  items: AssigneeTicketGroupingDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface StatusTicketGroupingDto {
  status: string;
  ticketCount: number;
}

export interface StatusTicketGroupingListDto {
  items: StatusTicketGroupingDto[];
}

export interface CategoryTicketGroupingDto {
  category: string;
  ticketCount: number;
}

export interface CategoryTicketGroupingListDto {
  items: CategoryTicketGroupingDto[];
}

export interface MobileVersionsDto {
  /**
   * Minimum supported Android version
   * @example "1.0.0"
   */
  minAndroidVersion: string;
  /**
   * Minimum supported iOS version
   * @example "1.0.0"
   */
  minIosVersion: string;
  /**
   * Latest available Android version
   * @example "2.1.0"
   */
  latestAndroidVersion: string;
  /**
   * Latest available iOS version
   * @example "2.1.0"
   */
  latestIosVersion: string;
}

export enum CreateProjectDtoProjectStatusEnum {
  Active = 'active',
  Archived = 'archived',
  OnHold = 'on-hold',
}

export enum UpdateProjectDtoProjectStatusEnum {
  Active = 'active',
  Archived = 'archived',
  OnHold = 'on-hold',
}

/** The status of the location */
export enum LocationDtoStatusEnum {
  Active = 'Active',
  Monitored = 'Monitored',
  Sold = 'Sold',
  Closed = 'Closed',
  UnderConstruction = 'Under Construction',
  NotActive = 'Not Active',
}

export enum LocationDtoSpendAreaStageEnum {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  SAVINGS_REALIZED = 'SAVINGS_REALIZED',
  SAVINGS_ESTIMATED = 'SAVINGS_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS = 'NEGOTIATIONS',
}

/** Status of the document field */
export enum LocationDtoDocumentFieldStatusEnum {
  COMPLETE = 'COMPLETE',
  MISSING_FIELDS = 'MISSING_FIELDS',
  UPLOAD_INVOICES = 'UPLOAD_INVOICES',
  NOT_APPLICABLE_REQUESTED = 'NOT_APPLICABLE_REQUESTED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum LocationDtoRequestedChangeEnum {
  ExcludeFromAudit = 'exclude_from_audit',
  IncludeInAudit = 'include_in_audit',
  ChangeSpendArea = 'change_spend_area',
  Create = 'create',
}

/**
 * The type of action to perform on the locations
 * @example "exclude_from_audit"
 */
export enum LocationActionBodyDtoActionTypeEnum {
  ExcludeFromAudit = 'exclude_from_audit',
  IncludeInAudit = 'include_in_audit',
  ChangeSpendArea = 'change_spend_area',
}

export enum UpdateLocationDtoStatusEnum {
  Active = 'Active',
  Monitored = 'Monitored',
  Sold = 'Sold',
  Closed = 'Closed',
  UnderConstruction = 'Under Construction',
  NotActive = 'Not Active',
}

export enum UpdateLocationDtoSpendAreaStageEnum {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  SAVINGS_REALIZED = 'SAVINGS_REALIZED',
  SAVINGS_ESTIMATED = 'SAVINGS_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS = 'NEGOTIATIONS',
}

export enum UpdateLocationDtoDocumentFieldStatusEnum {
  COMPLETE = 'COMPLETE',
  MISSING_FIELDS = 'MISSING_FIELDS',
  UPLOAD_INVOICES = 'UPLOAD_INVOICES',
  NOT_APPLICABLE_REQUESTED = 'NOT_APPLICABLE_REQUESTED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

/** The requested change action, can be one of LocationAction values or an empty string */
export enum UpdateLocationDtoRequestedChangeEnum {
  ExcludeFromAudit = 'exclude_from_audit',
  IncludeInAudit = 'include_in_audit',
  ChangeSpendArea = 'change_spend_area',
  Create = 'create',
}

/** @example "user" */
export enum PreferenceDtoTypeEnum {
  User = 'user',
  Organization = 'organization',
  Global = 'global',
}

/** @example "user" */
export enum PreferenceControllerUpsertPreferencesParamsTypeEnum {
  User = 'user',
  Organization = 'organization',
  Global = 'global',
}

/** @example "user" */
export enum PreferenceControllerGetPreferencesParamsTypeEnum {
  User = 'user',
  Organization = 'organization',
  Global = 'global',
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem)
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== 'string'
    ) {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then(response => response.data);
  };
}

/**
 * @title SIB service
 * @version 1.0
 * @baseUrl /api
 * @contact
 *
 * SIB service API
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  healthCheck = {
    /**
     * No description
     *
     * @tags Health-Check
     * @name ApiControllerGetHello
     * @request GET:/health-check
     */
    apiControllerGetHello: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/health-check`,
        method: 'GET',
        ...params,
      }),
  };
  queues = {
    /**
     * @description Get information about all available queues including job counts
     *
     * @tags Queues
     * @name QueueControllerGetAllQueues
     * @summary List all queues
     * @request GET:/queues
     * @secure
     */
    queueControllerGetAllQueues: (params: RequestParams = {}) =>
      this.request<QueueInfoDto[], void>({
        path: `/queues`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get all jobs (waiting, active, completed, failed, delayed) in a specific queue
     *
     * @tags Queues
     * @name QueueControllerGetQueueJobs
     * @summary List jobs in a queue
     * @request GET:/queues/{queueName}/jobs
     * @secure
     */
    queueControllerGetQueueJobs: (
      queueName: string,
      params: RequestParams = {}
    ) =>
      this.request<ListQueueJobsDto, void>({
        path: `/queues/${queueName}/jobs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retry a specific failed job in a queue
     *
     * @tags Queues
     * @name QueueControllerRetryJob
     * @summary Retry a failed job
     * @request POST:/queues/{queueName}/jobs/{jobId}/retry
     * @secure
     */
    queueControllerRetryJob: (
      queueName: string,
      jobId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/queues/${queueName}/jobs/${jobId}/retry`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Delete a specific job from a queue
     *
     * @tags Queues
     * @name QueueControllerDeleteJob
     * @summary Delete a job from a queue
     * @request DELETE:/queues/{queueName}/jobs/{jobId}
     * @secure
     */
    queueControllerDeleteJob: (
      queueName: string,
      jobId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/queues/${queueName}/jobs/${jobId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  organization = {
    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerBulkUpdate
     * @request PATCH:/organization/{organizationId}/document/bulk-update
     * @secure
     */
    documentControllerBulkUpdate: (
      organizationId: string,
      data: BulkUpdateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto[], void>({
        path: `/organization/${organizationId}/document/bulk-update`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetUploadUrl
     * @request POST:/organization/{organizationId}/document/upload-url
     * @secure
     */
    documentControllerGetUploadUrl: (
      organizationId: string,
      data: CreateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<GenerateUploadUrlResponseDto, void>({
        path: `/organization/${organizationId}/document/upload-url`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerUploadFile
     * @request POST:/organization/{organizationId}/document/upload
     * @secure
     */
    documentControllerUploadFile: (
      organizationId: string,
      data: UploadDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, void>({
        path: `/organization/${organizationId}/document/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerPostprocessUploadedFile
     * @request POST:/organization/{organizationId}/document/postprocess
     * @secure
     */
    documentControllerPostprocessUploadedFile: (
      organizationId: string,
      data: PostprocessUploadedDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organization/${organizationId}/document/postprocess`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetAllDocuments
     * @request GET:/organization/{organizationId}/document
     * @secure
     */
    documentControllerGetAllDocuments: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - stage
         * - vendor
         * - name
         * - createdAt
         * - updatedAt
         * - providedBy
         * - type
         * - spendCategory
         * - id
         * - uploadedBy
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - additionalColumns.key
         * - categoryManager
         * - paymentFrequency
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - anomaly
         * - matchingDocuments
         * - flagged
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | stage                        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | vendor                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | name                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdAt                    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | updatedAt                    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | providedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | type                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | spendCategory                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | id                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | uploadedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | startDate                    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | endDate                      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | renewalDate                  | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | annualContractValue          | number | eq, neq, gt, gte, lt, lte, between |  |
         * | notToExceed                  | boolean | eq, neq, isnull, isnotnull |  |
         * | annualPriceIncrease          | boolean | eq, neq, isnull, isnotnull |  |
         * | earlyTerminationFee          | boolean | eq, neq, isnull, isnotnull |  |
         * | contractType                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | additionalColumns.key        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | categoryManager              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | paymentFrequency             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | cancellationDateNoticePeriod | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | autoRenewalClause            | boolean | eq, neq, isnull, isnotnull |  |
         * | autoRenewalLength            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | notToExceedPercentage        | number | eq, neq, gt, gte, lt, lte, between |  |
         * | anomaly                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | matchingDocuments            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | tags                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | flagged                      | boolean | eq, neq, isnull, isnotnull |  |
         * | virtual                      | boolean | eq, neq, isnull, isnotnull |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: tag.name, filename */
        searchTerm?: string;
        /**
         * This field returns documents with end date after or equal to the given date or where end date is null
         * @format date-time
         */
        afterEndDateOrNull?: string;
        /** If passed it will return only virtual invoices that matches the origin filename pattern */
        originFilename?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DocumentListDto, void>({
        path: `/organization/${organizationId}/document`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetOneDocument
     * @request GET:/organization/{organizationId}/document/{id}
     * @secure
     */
    documentControllerGetOneDocument: (
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, void>({
        path: `/organization/${organizationId}/document/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerDeleteDocuement
     * @request DELETE:/organization/{organizationId}/document/{id}
     * @secure
     */
    documentControllerDeleteDocuement: (
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/organization/${organizationId}/document/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerUpdate
     * @request PATCH:/organization/{organizationId}/document/{id}
     * @secure
     */
    documentControllerUpdate: (
      id: string,
      organizationId: string,
      data: UpdateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, void>({
        path: `/organization/${organizationId}/document/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetUploadStatus
     * @request GET:/organization/{organizationId}/document/batch/{batchId}/status
     * @secure
     */
    documentControllerGetUploadStatus: (
      organizationId: string,
      batchId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentUploadStatusListDto, void>({
        path: `/organization/${organizationId}/document/batch/${batchId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetSpendCategorySelectList
     * @request GET:/organization/{organizationId}/document/select-list/spend-categories
     * @secure
     */
    documentControllerGetSpendCategorySelectList: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organization/${organizationId}/document/select-list/spend-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetDocumentTypeSelectList
     * @request GET:/organization/{organizationId}/document/select-list/document-types
     * @secure
     */
    documentControllerGetDocumentTypeSelectList: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organization/${organizationId}/document/select-list/document-types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetVendorSelectList
     * @request GET:/organization/{organizationId}/document/select-list/vendors
     * @secure
     */
    documentControllerGetVendorSelectList: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organization/${organizationId}/document/select-list/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetOrganizationById
     * @request GET:/organization/{id}
     * @secure
     */
    organizationControllerGetOrganizationById: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationDto, void>({
        path: `/organization/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetYourTeam
     * @request GET:/organization/{id}/your-team
     * @secure
     */
    organizationControllerGetYourTeam: (
      id: string,
      query: {
        billingContactProvider: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<YourTeamDto, void>({
        path: `/organization/${id}/your-team`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetAllSpendCategories
     * @request GET:/organization/{id}/spend-categories
     * @secure
     */
    organizationControllerGetAllSpendCategories: (
      id: string,
      query: {
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: name, id
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: name, id
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendCategoryListDto, void>({
        path: `/organization/${id}/spend-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetOrganizationSpendCategory
     * @request GET:/organization/{id}/spend-areas
     * @secure
     */
    organizationControllerGetOrganizationSpendCategory: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<SpendAreaResourceDto, void>({
        path: `/organization/${id}/spend-areas`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetOrganizationSavingsSummary
     * @request GET:/organization/{id}/savings-summary
     * @secure
     */
    organizationControllerGetOrganizationSavingsSummary: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<SavingSummaryResponseDto, void>({
        path: `/organization/${id}/savings-summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerFindAllTasks
     * @request GET:/organization/{id}/tasks
     * @secure
     */
    organizationControllerFindAllTasks: (
      id: string,
      query: {
        searchTerm?: string;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: title, description, completed, priorityLevel, createdAt, updatedAt, deadline, completedAt, timeLogged, estimatedTime, referenceLink, referenceName, seenAt, seen, taskTags.tag.uuid, taskTags.tag.name, taskTags.tag.color, taskTags.tag.createdBy, taskTags.contactId, taskTags.employeeId, taskTags.type
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: title, description, completed, priorityLevel, createdAt, updatedAt, deadline, completedAt, timeLogged, estimatedTime, category, referenceLink, referenceName, organizationId, seenAt, seen, taskTags.tag.uuid, taskTags.tag.name, taskTags.tag.color, taskTags.tag.createdBy, taskTags.contactId, taskTags.employeeId, taskTags.type, assignee, subauditId, projectId
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         * Enum values:
         *
         *  priorityLevel: low, medium, high
         *
         * category: Vendor Call, Client Call, Internal outreach, Vendor email, Client email, Data analysis, Report build, Data gathering, Invoice Collection, Research, Other
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/organization/${id}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerFindAllUsers
     * @request GET:/organization/{id}/users
     * @secure
     */
    organizationControllerFindAllUsers: (
      id: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by name or email address */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExternalUserPartialListDto, void>({
        path: `/organization/${id}/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerFindAllowedDomains
     * @request GET:/organization/{id}/allowed-domains
     * @secure
     */
    organizationControllerFindAllowedDomains: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<AllowedDomainListDto, void>({
        path: `/organization/${id}/allowed-domains`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetInvitedUsers
     * @request GET:/organization/{id}/invited-users
     * @secure
     */
    organizationControllerGetInvitedUsers: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<InvitedUserDto[], void>({
        path: `/organization/${id}/invited-users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerDeleteInvitedUser
     * @request DELETE:/organization/{id}/invited-users/{userId}
     * @secure
     */
    organizationControllerDeleteInvitedUser: (
      id: string,
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organization/${id}/invited-users/${userId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetAdditionalColumns
     * @request GET:/organization/{id}/additional-columns/{tableName}
     * @secure
     */
    organizationControllerGetAdditionalColumns: (
      id: string,
      tableName: string,
      params: RequestParams = {}
    ) =>
      this.request<AdditionalColumnsListDto, void>({
        path: `/organization/${id}/additional-columns/${tableName}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name ContactsControllerGetOrganizationContacts
     * @request GET:/organization/{organizationId}/contacts
     * @secure
     */
    contactsControllerGetOrganizationContacts: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - email
         * - phone
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | email | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | phone | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContactsListDto, void>({
        path: `/organization/${organizationId}/contacts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name ContactsControllerGetVendorOrganizationContacts
     * @request GET:/organization/{organizationId}/contacts/vendors
     * @secure
     */
    contactsControllerGetVendorOrganizationContacts: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - email
         * - phone
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | email | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | phone | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContactsListDto, void>({
        path: `/organization/${organizationId}/contacts/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerFindAll
     * @request GET:/organization/{organizationId}/subaudits
     * @secure
     */
    subauditsControllerFindAll: (
      organizationId: string,
      query: {
        searchTerm?: string;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: createdAt, updatedAt
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: id, createdAt, updatedAt, spendAmount, subauditStage, vendorAccountNumber, onHold
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SubauditsListDto, void>({
        path: `/organization/${organizationId}/subaudits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerCreate
     * @request POST:/organization/{organizationId}/subaudits
     * @secure
     */
    subauditsControllerCreate: (
      organizationId: string,
      data: CreateSubauditDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerUpdate
     * @request PATCH:/organization/{organizationId}/subaudits/{id}
     * @secure
     */
    subauditsControllerUpdate: (
      organizationId: string,
      id: string,
      data: UpdateSubauditDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerFindOne
     * @request GET:/organization/{organizationId}/subaudits/{id}
     * @secure
     */
    subauditsControllerFindOne: (
      organizationId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerDeleteOne
     * @request DELETE:/organization/{organizationId}/subaudits/{id}
     * @secure
     */
    subauditsControllerDeleteOne: (
      organizationId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerGetSubauditComments
     * @request GET:/organization/{organizationId}/subaudit/{subauditId}/comments
     * @secure
     */
    subauditCommentsControllerGetSubauditComments: (
      organizationId: string,
      subauditId: string,
      query: {
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: id, createdAt, topic, content
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: id, content, topic, createdAt, updatedAt
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentListDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerCreateSubauditComment
     * @request POST:/organization/{organizationId}/subaudit/{subauditId}/comments
     * @secure
     */
    subauditCommentsControllerCreateSubauditComment: (
      organizationId: string,
      subauditId: string,
      data: CreateSubauditCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerGetSubauditComment
     * @request GET:/organization/{organizationId}/subaudit/{subauditId}/comments/{commentId}
     * @secure
     */
    subauditCommentsControllerGetSubauditComment: (
      organizationId: string,
      subauditId: string,
      commentId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments/${commentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerUpdateSubauditComment
     * @request PATCH:/organization/{organizationId}/subaudit/{subauditId}/comments/{commentId}
     * @secure
     */
    subauditCommentsControllerUpdateSubauditComment: (
      organizationId: string,
      subauditId: string,
      commentId: string,
      data: UpdateSubauditCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments/${commentId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerDeleteSubauditComment
     * @request DELETE:/organization/{organizationId}/subaudit/{subauditId}/comments/{commentId}
     * @secure
     */
    subauditCommentsControllerDeleteSubauditComment: (
      organizationId: string,
      subauditId: string,
      commentId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments/${commentId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerFindAllActionItems
     * @request GET:/organization/{organizationId}/action-items
     * @secure
     */
    actionItemControllerFindAllActionItems: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - description
         * - deadline
         * - completedAt
         * - spendAreaStage
         * - priorityLevel
         * - actionType
         * - createdAt
         * - updatedAt
         * - createdBy
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | title          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | description    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | deadline       | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | completedAt    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | spendAreaStage | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | priorityLevel  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | actionType     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | updatedAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | createdBy      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ActionItemListDto, void>({
        path: `/organization/${organizationId}/action-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerCreateActionItem
     * @request POST:/organization/{organizationId}/action-items
     * @secure
     */
    actionItemControllerCreateActionItem: (
      organizationId: string,
      data: CreateActionItemDto,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerFindOneActionItems
     * @request GET:/organization/{organizationId}/action-items/{actionItemId}
     * @secure
     */
    actionItemControllerFindOneActionItems: (
      actionItemId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items/${actionItemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerUpdateActionItem
     * @request PATCH:/organization/{organizationId}/action-items/{actionItemId}
     * @secure
     */
    actionItemControllerUpdateActionItem: (
      organizationId: string,
      actionItemId: string,
      data: UpdateActionItemDto,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items/${actionItemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerDeleteActionItem
     * @request DELETE:/organization/{organizationId}/action-items/{actionItemId}
     * @secure
     */
    actionItemControllerDeleteActionItem: (
      actionItemId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items/${actionItemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request Spend Area
     * @name RequestSpendAreaControllerCreateRequestedSpendArea
     * @request POST:/organization/{id}/request-spend-areas/{spendAreaId}
     * @secure
     */
    requestSpendAreaControllerCreateRequestedSpendArea: (
      id: string,
      spendAreaId: string,
      params: RequestParams = {}
    ) =>
      this.request<any, void | RequestSpendAreaResponseDto>({
        path: `/organization/${id}/request-spend-areas/${spendAreaId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request Spend Area
     * @name RequestSpendAreaControllerCreateManyRequestedSpendArea
     * @request POST:/organization/{id}/request-spend-areas
     * @secure
     */
    requestSpendAreaControllerCreateManyRequestedSpendArea: (
      id: string,
      data: RequestSpendAreaBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<any, void | RequestSpendAreaResponseDto>({
        path: `/organization/${id}/request-spend-areas`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChildOrganization
     * @name ChildOrganizationControllerGetChildrenOrganizations
     * @request GET:/organization/{organizationId}/child-organizations
     * @secure
     */
    childOrganizationControllerGetChildrenOrganizations: (
      organizationId: string,
      query: {
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: name
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: name, micrositesEnabled
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ChildOrganizationListDto, void>({
        path: `/organization/${organizationId}/child-organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceFile
     * @request GET:/organization/{organizationId}/billings/netsuite/invoices/{invoiceId}/file
     * @secure
     */
    billingsControllerGetInvoiceFile: (
      invoiceId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organization/${organizationId}/billings/netsuite/invoices/${invoiceId}/file`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceNetsuiteSummary
     * @request GET:/organization/{organizationId}/billings/netsuite/summary
     * @secure
     */
    billingsControllerGetInvoiceNetsuiteSummary: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceSummaryDto, void>({
        path: `/organization/${organizationId}/billings/netsuite/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceNetsuite
     * @request GET:/organization/{organizationId}/billings/netsuite
     * @secure
     */
    billingsControllerGetInvoiceNetsuite: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - invoiceNumber
         * - date
         * - dueDate
         * - amount
         * - balance
         * - status
         * - locationId
         * - locationName
         * - accountNumber
         * - vendorName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | dueDate       | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci | paid, unpaid, partially-paid |
         * | date          | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | vendorName    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | invoiceNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | paymentAmount | number | eq, neq, gt, gte, lt, lte, between |  |
         * | balance       | number | eq, neq, gt, gte, lt, lte, between |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<NetsuiteInvoiceListDto, void>({
        path: `/organization/${organizationId}/billings/netsuite`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceVectorSummary
     * @request GET:/organization/{organizationId}/billings/vector/summary
     * @secure
     */
    billingsControllerGetInvoiceVectorSummary: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceSummaryDto, void>({
        path: `/organization/${organizationId}/billings/vector/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoice
     * @request GET:/organization/{organizationId}/billings/vector
     * @secure
     */
    billingsControllerGetInvoice: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - invoiceNumber
         * - date
         * - dueDate
         * - amount
         * - balance
         * - status
         * - locationId
         * - locationName
         * - accountNumber
         * - vendorName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | dueDate       | date | between |  |
         * | status        | string | eq,in | paid, unpaid, partially-paid |
         * | date          | date | between |  |
         * | vendorName    | string | like |  |
         * | invoiceNumber | string | like |  |
         * | paymentAmount | number | eq |  |
         * | balance       | number | eq |  |
         * | locationName  | string | like |  |
         * | locationId    | number | eq |  |
         * | accountNumber | string | like |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<VectorInvoiceListResponseDto, void>({
        path: `/organization/${organizationId}/billings/vector`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerCreateZipJobForBillingsNetsuite
     * @request POST:/organization/{organizationId}/billings/netsuite/zip
     * @secure
     */
    billingsControllerCreateZipJobForBillingsNetsuite: (
      organizationId: string,
      data: CreateZipNetsuiteRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateBillingsZipResponseDto, void>({
        path: `/organization/${organizationId}/billings/netsuite/zip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceFileById
     * @request GET:/organization/{organizationId}/billings/netsuite/invoices/{invoiceId}/files/{fileId}
     * @secure
     */
    billingsControllerGetInvoiceFileById: (
      invoiceId: string,
      fileId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/billings/netsuite/invoices/${invoiceId}/files/${fileId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerCreateZipJobForBillingsVector
     * @request POST:/organization/{organizationId}/billings/vector/zip
     * @secure
     */
    billingsControllerCreateZipJobForBillingsVector: (
      organizationId: string,
      data: CreateZipVectorRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateBillingsZipResponseDto, void>({
        path: `/organization/${organizationId}/billings/vector/zip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name OrganizationLocationsControllerFindAllSelectList
     * @request GET:/organization/{organizationId}/locations/select-list
     * @secure
     */
    organizationLocationsControllerFindAllSelectList: (
      organizationId: string,
      query: {
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: name, address, city, state, zip
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: name, address, city, state, zip
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<LocationSelectListDto, void>({
        path: `/organization/${organizationId}/locations/select-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name ArchiveDocumentControllerCreateZipJob
     * @request POST:/organization/{organizationId}/document/zip
     * @secure
     */
    archiveDocumentControllerCreateZipJob: (
      organizationId: string,
      data: CreateArchiveDocumentsRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<ArchiveDocumentsResponseDto, void>({
        path: `/organization/${organizationId}/document/zip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerGetTickets
     * @request GET:/organization/{organizationId}/tickets
     * @secure
     */
    organizationTicketsControllerGetTickets: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/organization/${organizationId}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerCreateTicket
     * @request POST:/organization/{organizationId}/tickets
     * @secure
     */
    organizationTicketsControllerCreateTicket: (
      organizationId: string,
      data: CreateTicketDto,
      params: RequestParams = {}
    ) =>
      this.request<TicketWithDetailsDto, void>({
        path: `/organization/${organizationId}/tickets`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerGetTicket
     * @request GET:/organization/{organizationId}/tickets/{ticketId}
     * @secure
     */
    organizationTicketsControllerGetTicket: (
      ticketId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<TicketWithDetailsDto, void>({
        path: `/organization/${organizationId}/tickets/${ticketId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerCreateExternalComment
     * @request POST:/organization/{organizationId}/tickets/{ticketId}/comments
     * @secure
     */
    organizationTicketsControllerCreateExternalComment: (
      ticketId: string,
      organizationId: string,
      data: CreateTicketCommentExternalDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateTicketCommentResponseDto, void>({
        path: `/organization/${organizationId}/tickets/${ticketId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  externalUsers = {
    /**
     * No description
     *
     * @tags External Users
     * @name ExternalUsersControllerGetAllList
     * @request GET:/external-users
     * @secure
     */
    externalUsersControllerGetAllList: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by name or email address */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExternalUserPartialListDto, void>({
        path: `/external-users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users
     * @name ExternalUsersControllerFindAllCoworkers
     * @request GET:/external-users/coworkers
     * @secure
     */
    externalUsersControllerFindAllCoworkers: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by name or email address */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExternalUserPartialListDto, void>({
        path: `/external-users/coworkers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users
     * @name ExternalUsersControllerUpdateExternalUser
     * @request PATCH:/external-users/{id}
     * @secure
     */
    externalUsersControllerUpdateExternalUser: (
      id: string,
      data: UpdateExternalUserDto,
      params: RequestParams = {}
    ) =>
      this.request<PlainExternalUserDto, void>({
        path: `/external-users/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  token = {
    /**
     * No description
     *
     * @tags Token
     * @name TokenControllerGetFranzOboToken
     * @request GET:/token/franz/{organizationId}
     * @secure
     */
    tokenControllerGetFranzOboToken: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/token/franz/${organizationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  task = {
    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerCreate
     * @request POST:/task
     * @secure
     */
    taskControllerCreate: (data: CreateTaskDto, params: RequestParams = {}) =>
      this.request<TaskDto, void>({
        path: `/task`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerFindAll
     * @request GET:/task
     * @secure
     */
    taskControllerFindAll: (
      query: {
        searchTerm?: string;
        userId?: string;
        createdBy?: string;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: title, description, completed, priorityLevel, createdAt, updatedAt, deadline, completedAt, timeLogged, estimatedTime, referenceLink, referenceName, seenAt, seen, taskTags.tag.uuid, taskTags.tag.name, taskTags.tag.color, taskTags.tag.createdBy, taskTags.contactId, taskTags.employeeId, taskTags.type
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: title, description, completed, priorityLevel, createdAt, updatedAt, deadline, completedAt, timeLogged, estimatedTime, category, referenceLink, referenceName, organizationId, seenAt, seen, taskTags.tag.uuid, taskTags.tag.name, taskTags.tag.color, taskTags.tag.createdBy, taskTags.contactId, taskTags.employeeId, taskTags.type, assignee, subauditId, projectId
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         * Enum values:
         *
         *  priorityLevel: low, medium, high
         *
         * category: Vendor Call, Client Call, Internal outreach, Vendor email, Client email, Data analysis, Report build, Data gathering, Invoice Collection, Research, Other
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/task`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerFindOne
     * @request GET:/task/{id}
     * @secure
     */
    taskControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<TaskDto, void>({
        path: `/task/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerUpdate
     * @request PUT:/task/{id}
     * @secure
     */
    taskControllerUpdate: (
      id: string,
      data: UpdateTaskDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskDto, void>({
        path: `/task/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerDeleteOne
     * @request DELETE:/task/{id}
     * @secure
     */
    taskControllerDeleteOne: (
      id: string,
      query?: {
        /** Whether to also delete all follow-up tasks */
        cascadeFollowUps?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<DeleteResult, void>({
        path: `/task/${id}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerGetAssignedUsersWithTaskCountsByCreator
     * @request GET:/task/assigned-users-by-creator/task-count
     * @secure
     */
    taskControllerGetAssignedUsersWithTaskCountsByCreator: (
      query: {
        /**
         * Global search term.
         *
         * Searchable fields: task.title, task.description, subtask.title, subtask.description, tag.name, task.category, taskTag.contact.name, taskTag.contact.email, taskTag.employee.name, taskTag.employee.emailAddress
         */
        searchTerm?: string;
        /** Filter by completion status. If true, returns only completed tasks. If false, returns only non-completed tasks. */
        completed?: boolean;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties:
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields:
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<AssignedUserTaskSummaryListDto, void>({
        path: `/task/assigned-users-by-creator/task-count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerLogTime
     * @request PATCH:/task/{id}/log-time
     * @secure
     */
    taskControllerLogTime: (
      id: string,
      data: LogTimeDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskDto, void>({
        path: `/task/${id}/log-time`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerImportTasks
     * @request POST:/task/import/{userId}
     * @secure
     */
    taskControllerImportTasks: (
      userId: string,
      query: {
        ownerFilter: string;
      },
      data: ImportTasksDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskDto[], void>({
        path: `/task/import/${userId}`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerCreateManyTasks
     * @request POST:/task/many
     * @secure
     */
    taskControllerCreateManyTasks: (
      data: CreateTaskDto[],
      params: RequestParams = {}
    ) =>
      this.request<TaskDto[], void>({
        path: `/task/many`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  tasks = {
    /**
     * No description
     *
     * @tags TaskHistory
     * @name TaskHistoryControllerFindAllChangeLogs
     * @request GET:/tasks/{taskUuid}/versions/changelogs
     * @secure
     */
    taskHistoryControllerFindAllChangeLogs: (
      taskUuid: string,
      params: RequestParams = {}
    ) =>
      this.request<TaskVersionChangelogList, void>({
        path: `/tasks/${taskUuid}/versions/changelogs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask Versions
     * @name SubtaskVersionsControllerFindAllChangeLogs
     * @request GET:/tasks/{taskId}/subtasks/{subtaskId}/versions/changelogs
     * @secure
     */
    subtaskVersionsControllerFindAllChangeLogs: (
      taskId: string,
      subtaskId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskVersionChangelogList, void>({
        path: `/tasks/${taskId}/subtasks/${subtaskId}/versions/changelogs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task Tag Versions
     * @name TaskTagVersionsControllerFindAllChangeLogs
     * @request GET:/tasks/{taskId}/task-tags/versions
     * @secure
     */
    taskTagVersionsControllerFindAllChangeLogs: (
      taskId: string,
      params: RequestParams = {}
    ) =>
      this.request<TaskTagVersionChangelogList, void>({
        path: `/tasks/${taskId}/task-tags/versions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerCreate
     * @request POST:/tasks/{taskUuid}/subtasks
     * @secure
     */
    subtaskControllerCreate: (
      taskUuid: string,
      data: CreateSubtaskDto,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskDto, void>({
        path: `/tasks/${taskUuid}/subtasks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerFindAll
     * @request GET:/tasks/{taskUuid}/subtasks
     * @secure
     */
    subtaskControllerFindAll: (
      taskUuid: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - completed
         * - priorityLevel
         * - completed
         * - createdByEmail
         * - createdByName
         * - createdAt
         * - updatedAt
         * - updatedById
         * - priorityLevel
         * - taskId
         * - description
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | title          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | completed      | boolean | eq, neq, isnull, isnotnull |  |
         * | description    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | taskId         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | updatedAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | updatedById    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | priorityLevel  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci | low, medium, high |
         * | createdByEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdByName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SubtaskListDto, void>({
        path: `/tasks/${taskUuid}/subtasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerFindOne
     * @request GET:/tasks/{taskUuid}/subtasks/{subtaskId}
     * @secure
     */
    subtaskControllerFindOne: (
      taskUuid: string,
      subtaskId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskDto, void>({
        path: `/tasks/${taskUuid}/subtasks/${subtaskId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerUpdate
     * @request PUT:/tasks/{taskUuid}/subtasks/{subtaskId}
     * @secure
     */
    subtaskControllerUpdate: (
      taskUuid: string,
      subtaskId: string,
      data: UpdateSubtaskDto,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskDto, void>({
        path: `/tasks/${taskUuid}/subtasks/${subtaskId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerDeleteOne
     * @request DELETE:/tasks/{taskUuid}/subtasks/{subtaskId}
     * @secure
     */
    subtaskControllerDeleteOne: (
      taskUuid: string,
      subtaskId: string,
      params: RequestParams = {}
    ) =>
      this.request<DeleteResult, void>({
        path: `/tasks/${taskUuid}/subtasks/${subtaskId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task Comment
     * @name TaskCommentControllerFindAll
     * @request GET:/tasks/{taskId}/comments
     */
    taskCommentControllerFindAll: (
      taskId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - createdAt
         * - updatedAt
         * - comment
         * - createdByName
         * - createdByEmail
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | comment        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | taskId         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | updatedAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | createdByName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdByEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskCommentListDto, any>({
        path: `/tasks/${taskId}/comments`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task Comment
     * @name TaskCommentControllerCreate
     * @request POST:/tasks/{taskId}/comments
     */
    taskCommentControllerCreate: (
      taskId: string,
      data: CreateTaskCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskCommentDto, any>({
        path: `/tasks/${taskId}/comments`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  userSettings = {
    /**
     * No description
     *
     * @tags User Settings
     * @name UserSettingsControllerGetUserSettings
     * @summary Get user settings
     * @request GET:/user-settings
     * @secure
     */
    userSettingsControllerGetUserSettings: (params: RequestParams = {}) =>
      this.request<any, void | UserSettingsResponseDto>({
        path: `/user-settings`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name UserSettingsControllerUpdateUserSettings
     * @summary Update user settings (partial update)
     * @request PATCH:/user-settings
     * @secure
     */
    userSettingsControllerUpdateUserSettings: (
      data: UpdateUserSettingsDto,
      params: RequestParams = {}
    ) =>
      this.request<any, void | UserSettingsResponseDto>({
        path: `/user-settings`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  team = {
    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerFindAll
     * @request GET:/team
     * @secure
     */
    teamControllerFindAll: (
      query: {
        withUsers?: boolean;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: name, description, subtitle, createdAt, updatedAt
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: name, description, subtitle, createdAt, updatedAt
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamListDto, void>({
        path: `/team`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerFindOne
     * @request GET:/team/{teamUuid}
     * @secure
     */
    teamControllerFindOne: (teamUuid: string, params: RequestParams = {}) =>
      this.request<TeamDto, void>({
        path: `/team/${teamUuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerGetMembers
     * @request GET:/team/{teamUuid}/members
     * @secure
     */
    teamControllerGetMembers: (
      teamUuid: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by name or email address */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamMemberListDto, void>({
        path: `/team/${teamUuid}/members`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerGetTaskCount
     * @request GET:/team/{teamUuid}/task-count
     * @secure
     */
    teamControllerGetTaskCount: (
      teamUuid: string,
      query?: {
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamTaskCountDto, void>({
        path: `/team/${teamUuid}/task-count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerUpdateTeamMembers
     * @request PATCH:/team/{teamUuid}/team-members
     * @secure
     */
    teamControllerUpdateTeamMembers: (
      teamUuid: string,
      data: UpdateTeamMembersDto,
      params: RequestParams = {}
    ) =>
      this.request<UpdateTeamMembersResponseDto, void>({
        path: `/team/${teamUuid}/team-members`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGetCurrentUser
     * @request GET:/user/current
     * @secure
     */
    usersControllerGetCurrentUser: (params: RequestParams = {}) =>
      this.request<CurrentUserDto, void>({
        path: `/user/current`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGetUserOrganizations
     * @request GET:/user/organizations
     * @secure
     */
    usersControllerGetUserOrganizations: (
      query: {
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: name, id
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: name
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<UserOrganizationsListDto, void>({
        path: `/user/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerInviteUser
     * @request POST:/user/{organizationId}/invite
     * @secure
     */
    usersControllerInviteUser: (
      organizationId: string,
      data: InviteUserBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<InviteUserResponseDto, void>({
        path: `/user/${organizationId}/invite`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGetInvitedUsers
     * @request GET:/user/invited-users
     * @secure
     */
    usersControllerGetInvitedUsers: (params: RequestParams = {}) =>
      this.request<InvitedUserDto[], void>({
        path: `/user/invited-users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerDeleteInvitedUser
     * @request DELETE:/user/invited-users/{userId}
     * @secure
     */
    usersControllerDeleteInvitedUser: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/user/invited-users/${userId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersControllerHasUserAccess
     * @request GET:/user/{userId}/organizations/{organizationId}
     * @secure
     */
    usersControllerHasUserAccess: (
      userId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/user/${userId}/organizations/${organizationId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  spendAndAnalysis = {
    /**
     * No description
     *
     * @tags SpendAndAnalysis
     * @name SpendAndAnalysisControllerGetOrganizationSavingsSummary
     * @request GET:/spend-and-analysis/{id}/spend-areas-savings-spend
     * @secure
     */
    spendAndAnalysisControllerGetOrganizationSavingsSummary: (
      id: string,
      query?: {
        /**
         * Optional array of spend areas to filter the results
         * @example ["Waste","Treasury"]
         */
        spendArea?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendAreasSavingsSpendResponseDto, void>({
        path: `/spend-and-analysis/${id}/spend-areas-savings-spend`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpendAndAnalysis
     * @name SpendAndAnalysisControllerGetAnnualSavingsForSpendArea
     * @request GET:/spend-and-analysis/{id}/annual-savings-for-spend-area
     * @secure
     */
    spendAndAnalysisControllerGetAnnualSavingsForSpendArea: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<AnnualSavingsForSpendAreaResponseDto, void>({
        path: `/spend-and-analysis/${id}/annual-savings-for-spend-area`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  tickets = {
    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerGetTicketFiles
     * @request GET:/tickets/{ticketId}/files
     * @secure
     */
    ticketFilesControllerGetTicketFiles: (
      ticketId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - filename
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | filename | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketFileListDto, void>({
        path: `/tickets/${ticketId}/files`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerMoveToDocumentRepo
     * @request PUT:/tickets/{ticketId}/files/{fileId}/documents-repo/add
     * @secure
     */
    ticketFilesControllerMoveToDocumentRepo: (
      ticketId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/tickets/${ticketId}/files/${fileId}/documents-repo/add`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerRemoveFromDocumentRepo
     * @request PUT:/tickets/{ticketId}/files/{fileId}/documents-repo/remove
     * @secure
     */
    ticketFilesControllerRemoveFromDocumentRepo: (
      ticketId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/tickets/${ticketId}/files/${fileId}/documents-repo/remove`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerDeleteTicketFile
     * @request DELETE:/tickets/{ticketId}/files/{fileId}
     * @secure
     */
    ticketFilesControllerDeleteTicketFile: (
      ticketId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/tickets/${ticketId}/files/${fileId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerGetTickets
     * @request GET:/tickets
     * @secure
     */
    ticketsControllerGetTickets: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerGetTicket
     * @request GET:/tickets/{ticketId}
     * @secure
     */
    ticketsControllerGetTicket: (
      ticketId: string,
      params: RequestParams = {}
    ) =>
      this.request<TicketDto, void>({
        path: `/tickets/${ticketId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerUpdateTicket
     * @request PUT:/tickets/{ticketId}
     * @secure
     */
    ticketsControllerUpdateTicket: (
      ticketId: string,
      data: UpdateTicketDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/tickets/${ticketId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Comments
     * @name TicketsCommentsControllerCreateComment
     * @request POST:/tickets/{ticketId}/comments
     * @secure
     */
    ticketsCommentsControllerCreateComment: (
      ticketId: string,
      data: CreateTicketCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/tickets/${ticketId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Comments
     * @name TicketsCommentsControllerGetCommentsByTicketId
     * @request GET:/tickets/{ticketId}/comments
     * @secure
     */
    ticketsCommentsControllerGetCommentsByTicketId: (
      ticketId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | comment | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | scope   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** SearchTerm allows to filter results by: comment content */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketCommentListDto, void>({
        path: `/tickets/${ticketId}/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByOrganization
     * @request GET:/tickets/group/organization
     * @secure
     */
    ticketGroupingControllerGroupByOrganization: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationTicketCountListDto, void>({
        path: `/tickets/group/organization`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByAssignee
     * @request GET:/tickets/group/assignee
     * @secure
     */
    ticketGroupingControllerGroupByAssignee: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AssigneeTicketGroupingListDto, void>({
        path: `/tickets/group/assignee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByStatus
     * @request GET:/tickets/group/status
     * @secure
     */
    ticketGroupingControllerGroupByStatus: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void | StatusTicketGroupingListDto>({
        path: `/tickets/group/status`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByCatgory
     * @request GET:/tickets/group/category
     * @secure
     */
    ticketGroupingControllerGroupByCatgory: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void | CategoryTicketGroupingListDto>({
        path: `/tickets/group/category`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  };
  notifications = {
    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationControllerFindAll
     * @request GET:/notifications
     * @secure
     */
    notificationControllerFindAll: (
      query: {
        searchTerm?: string;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: createdAt, updatedAt, type, seenAt, priority, description
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: createdAt, updatedAt, type, seenAt, priority, description
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         * Enum values:
         *
         *  type: document_uploaded, task_completed, task_assigned, task_unassigned, task_edited, task_tagged, action_item_created, action_item_assigned, action_item_completed, action_item_deadline_approaching, action_item_overdue, ticket_comment_added, ticket_status_changed, spend_area_requested
         *
         * priority: success, error, warning, info
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<NotificationListDto, void>({
        path: `/notifications`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationControllerUpdate
     * @request PATCH:/notifications/{id}
     * @secure
     */
    notificationControllerUpdate: (
      id: string,
      data: UpdateNotificationDto,
      params: RequestParams = {}
    ) =>
      this.request<NotificationDto, void>({
        path: `/notifications/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationControllerGetCount
     * @request GET:/notifications/count
     * @secure
     */
    notificationControllerGetCount: (
      query: {
        searchTerm?: string;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: createdAt, updatedAt, type, seenAt, priority, description
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: createdAt, updatedAt, type, seenAt, priority, description
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         * Enum values:
         *
         *  type: document_uploaded, task_completed, task_assigned, task_unassigned, task_edited, task_tagged, action_item_created, action_item_assigned, action_item_completed, action_item_deadline_approaching, action_item_overdue, ticket_comment_added, ticket_status_changed, spend_area_requested
         *
         * priority: success, error, warning, info
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<NotificationCountDto, void>({
        path: `/notifications/count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Establishes a continuous SSE stream. **Note:** Swagger UI will keep loading indefinitely, because SSE does not close the connection.
     *
     * @tags Notifications (SSE)
     * @name NotificationSSeControllerSubscribe
     * @summary Subscribe to SSE notifications
     * @request GET:/notifications/{userId}
     * @secure
     */
    notificationSSeControllerSubscribe: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/notifications/${userId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  recurringTask = {
    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerCreateRecurringTask
     * @request POST:/recurring-task
     * @secure
     */
    recurringTaskControllerCreateRecurringTask: (
      data: CreateRecurringTaskDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateRecurringTaskDto, void>({
        path: `/recurring-task`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerFindAll
     * @request GET:/recurring-task
     * @secure
     */
    recurringTaskControllerFindAll: (
      query: {
        searchTerm?: string;
        userId?: string;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: title, description, priorityLevel, createdAt, updatedAt, referenceLink, referenceName, timeToComplete, timeToCompleteAmount, estimatedTime
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: title, description, priorityLevel, createdAt, updatedAt, category, referenceLink, referenceName, timeToComplete, timeToCompleteAmount, estimatedTime
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         * Enum values:
         *
         *  priorityLevel: low, medium, high
         *
         * category: Vendor Call, Client Call, Internal outreach, Vendor email, Client email, Data analysis, Report build, Data gathering, Invoice Collection, Research, Other
         *
         * timeToComplete: day, week, month
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<RecurringTaskListDto, void>({
        path: `/recurring-task`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerFindOne
     * @request GET:/recurring-task/{id}
     * @secure
     */
    recurringTaskControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<RecurringTaskDto, void>({
        path: `/recurring-task/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerUpdate
     * @request PATCH:/recurring-task/{id}
     * @secure
     */
    recurringTaskControllerUpdate: (
      id: string,
      data: UpdateRecurringTaskDto,
      params: RequestParams = {}
    ) =>
      this.request<RecurringTaskDto, void>({
        path: `/recurring-task/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerDeleteOne
     * @request DELETE:/recurring-task/{id}
     * @secure
     */
    recurringTaskControllerDeleteOne: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<DeleteResult, void>({
        path: `/recurring-task/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerGetRecurringTaskNextOccurrences
     * @request GET:/recurring-task/{id}/preview
     * @secure
     */
    recurringTaskControllerGetRecurringTaskNextOccurrences: (
      id: string,
      query: {
        limit: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/recurring-task/${id}/preview`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  };
  member = {
    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerFindUsersWithTaskByOrganization
     * @request GET:/member/{orgId}
     * @secure
     */
    memberControllerFindUsersWithTaskByOrganization: (
      orgId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by name or email address */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MemberListDto, void>({
        path: `/member/${orgId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetOrganizationMembersSummary
     * @request GET:/member/organizations/summary
     * @secure
     */
    memberControllerGetOrganizationMembersSummary: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | id                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | actionItem.completedAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        type?: OrganizationSpecialFilter;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationSummaryWithCountsListDto, void>({
        path: `/member/organizations/summary`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetOrganizationMembersSummaryByActiveTasks
     * @request GET:/member/organizations/summary/active-tasks
     * @secure
     */
    memberControllerGetOrganizationMembersSummaryByActiveTasks: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | id                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | actionItem.completedAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationSummaryWithMyActiveTasksCountListDto, void>({
        path: `/member/organizations/summary/active-tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetOrganizationMembersSummaryActionItems
     * @request GET:/member/organizations/summary/action-items
     * @secure
     */
    memberControllerGetOrganizationMembersSummaryActionItems: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | id                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | actionItem.completedAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        myOrganizations?: boolean;
        inProgress?: boolean;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationSummaryWithActionItemsCountListDto, void>({
        path: `/member/organizations/summary/action-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  organizationId = {
    /**
     * No description
     *
     * @tags Organization Audits
     * @name OrganizationAuditsControllerGetAllAuditsByOrganizationId
     * @request GET:/{organizationId}/audits
     * @secure
     */
    organizationAuditsControllerGetAllAuditsByOrganizationId: (
      organizationId: string,
      query: {
        searchTerm?: string;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties:
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields:
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditsListDto, void>({
        path: `/${organizationId}/audits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditVersions
     * @name SubauditVersionsControllerFindAllChangeLogs
     * @request GET:/{organizationId}/subaudit/{subauditId}/versions/changelogs
     * @secure
     */
    subauditVersionsControllerFindAllChangeLogs: (
      subauditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditVersionChangelogList, void>({
        path: `/${organizationId}/subaudit/${subauditId}/versions/changelogs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerFindAll
     * @request GET:/{organizationId}/document-tags
     * @secure
     */
    documentTagsControllerFindAll: (
      organizationId: string,
      query: {
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: name, createdAt, updatedAt, color
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: name, createdAt, updatedAt, color
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagsListDto, void>({
        path: `/${organizationId}/document-tags`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerCreate
     * @request POST:/{organizationId}/document-tags
     * @secure
     */
    documentTagsControllerCreate: (
      organizationId: string,
      data: CreateDocumentTagDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerFindOne
     * @request GET:/{organizationId}/document-tags/{uuid}
     * @secure
     */
    documentTagsControllerFindOne: (
      uuid: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags/${uuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerUpdate
     * @request PATCH:/{organizationId}/document-tags/{uuid}
     * @secure
     */
    documentTagsControllerUpdate: (
      uuid: string,
      organizationId: string,
      data: UpdateDocumentTagDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags/${uuid}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerDeleteOne
     * @request DELETE:/{organizationId}/document-tags/{uuid}
     * @secure
     */
    documentTagsControllerDeleteOne: (
      uuid: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags/${uuid}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  projects = {
    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerCreate
     * @request POST:/projects
     * @secure
     */
    projectControllerCreate: (
      data: CreateProjectDto,
      params: RequestParams = {}
    ) =>
      this.request<ProjectDto, void>({
        path: `/projects`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerGetTeamsWithProjects
     * @request GET:/projects/teams
     * @secure
     */
    projectControllerGetTeamsWithProjects: (
      query?: {
        /** Search by project name within each team */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamWithProjectsListDto, void>({
        path: `/projects/teams`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerFindOne
     * @request GET:/projects/{id}
     * @secure
     */
    projectControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<ProjectDto, void>({
        path: `/projects/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerUpdate
     * @request PATCH:/projects/{id}
     * @secure
     */
    projectControllerUpdate: (
      id: string,
      data: UpdateProjectDto,
      params: RequestParams = {}
    ) =>
      this.request<ProjectDto, void>({
        path: `/projects/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project relations
     * @name ProjectRelationsControllerGetProjectTickets
     * @request GET:/projects/{id}/tickets
     * @secure
     */
    projectRelationsControllerGetProjectTickets: (
      id: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/projects/${id}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project relations
     * @name ProjectRelationsControllerGetProjectTasks
     * @request GET:/projects/{id}/tasks
     * @secure
     */
    projectRelationsControllerGetProjectTasks: (
      id: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - priorityLevel
         * - referenceLink
         * - referenceName
         * - category
         * - completed
         * - completedAt
         * - deadline
         * - seenAt
         * - seen
         * - subauditId
         * - timeLogged
         * - estimatedTime
         * - assignee
         * - createdBy
         * - organization
         * - createdAt
         * - updatedAt
         * - project
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | completed            | boolean | eq, neq, isnull, isnotnull |  |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | deadline             | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | completedAt          | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between |  |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | organizationName     | string | like |  |
         * | seenAt               | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | seen                 | boolean | eq, neq, isnull, isnotnull |  |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by title, description, reference, assignee, creator, organization, or tag name */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/projects/${id}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  siteList = {
    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerGetOrganizationSavingsSummary
     * @request GET:/site-list/{id}/locations-list
     * @secure
     */
    siteListControllerGetOrganizationSavingsSummary: (
      id: string,
      query: {
        /** Start date for filtering savings/spend (YYYY-MM-DD) */
        startOfSavingsPeriod?: string;
        /** End date for filtering savings/spend (YYYY-MM-DD) */
        endOfSavingsPeriod?: string;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: id, address, city, state, status, zip, taxId, spendArea, spendApproved, savingsApproved, spendAreaStage, documentFieldStatus, locationIdentifier
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: id, address, city, state, zip, taxId, status, spendArea, spendApproved, spendAreaStage, savingsApproved, documentFieldStatus, locationIdentifier
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         * Enum values:
         *
         *  stages: MONITORING_SAVINGS, SAVINGS_REALIZED, SAVINGS_ESTIMATED, MOBILIZATION, NEGOTIATIONS
         *
         * status: Active, Monitored, Sold, Closed, Under Construction, Not Active
         *
         * documentFieldsStatus: COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<LocationListDto, void>({
        path: `/site-list/${id}/locations-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerGetFilesUnderValidation
     * @request GET:/site-list/{id}/files-under-validation
     * @secure
     */
    siteListControllerGetFilesUnderValidation: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<GetFilesUnderValidationResponseDto, void>({
        path: `/site-list/${id}/files-under-validation`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerUploadLocationList
     * @request POST:/site-list/{organizationId}/upload
     * @secure
     */
    siteListControllerUploadLocationList: (
      organizationId: string,
      data: UploadDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<ExcelUploadResponseDto, void>({
        path: `/site-list/${organizationId}/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerRequestLocationStatusChange
     * @request POST:/site-list/{organizationId}/location/actions
     * @secure
     */
    siteListControllerRequestLocationStatusChange: (
      organizationId: string,
      data: LocationActionBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationActionResponseDto, void>({
        path: `/site-list/${organizationId}/location/actions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerDeleteLocation
     * @request DELETE:/site-list/{id}
     * @secure
     */
    siteListControllerDeleteLocation: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/site-list/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerUpdateLocation
     * @request PATCH:/site-list/{id}
     * @secure
     */
    siteListControllerUpdateLocation: (
      id: string,
      data: UpdateLocationDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationDto, void>({
        path: `/site-list/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  actionItemTemplate = {
    /**
     * No description
     *
     * @tags ActionItemTemplate
     * @name ActionItemTemplateControllerGetAllActionItemTemplates
     * @request GET:/action-item-template
     * @secure
     */
    actionItemTemplateControllerGetAllActionItemTemplates: (
      query: {
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: id, name
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: id, name, description
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         * Enum values:
         *
         *  spendAreaStages: MONITORING_SAVINGS, SAVINGS_REALIZED, SAVINGS_ESTIMATED, MOBILIZATION, NEGOTIATIONS
         *
         * priorityLevels: low, medium, high
         *
         * actionTypes: meeting-link, link, file-upload
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ActionItemTemplateListDto, void>({
        path: `/action-item-template`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  organizations = {
    /**
     * No description
     *
     * @tags Power BI Reports
     * @name PowerBiReportsControllerGetPowerBiReports
     * @request GET:/organizations/{organizationId}/power-bi-reports
     * @secure
     */
    powerBiReportsControllerGetPowerBiReports: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - groupId
         * - reportId
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | groupId  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | reportId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PowerBiReportListDto, void>({
        path: `/organizations/${organizationId}/power-bi-reports`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Power BI Reports
     * @name PowerBiReportsControllerGetPowerBiReport
     * @request GET:/organizations/{organizationId}/power-bi-reports/{id}
     * @secure
     */
    powerBiReportsControllerGetPowerBiReport: (
      organizationId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<PowerBiReportDto, void>({
        path: `/organizations/${organizationId}/power-bi-reports/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name OrganizationVendorsControllerGetAllVendorsByOrganizationName
     * @request GET:/organizations/{organizationId}/vendors
     * @secure
     */
    organizationVendorsControllerGetAllVendorsByOrganizationName: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        serviceCategory?: string;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorsListDto, void>({
        path: `/organizations/${organizationId}/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name OrganizationVendorsControllerGetAllVendorServiceCategories
     * @request GET:/organizations/{organizationId}/vendors/service-categories
     * @secure
     */
    organizationVendorsControllerGetAllVendorServiceCategories: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<ServiceCategoryDto[], void>({
        path: `/organizations/${organizationId}/vendors/service-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VectorLocations
     * @name VectorLocationsControllerGetVectorLocations
     * @request GET:/organizations/{organizationId}/locations/vector
     * @secure
     */
    vectorLocationsControllerGetVectorLocations: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - address
         * - city
         * - state
         * - zipCode
         * - status
         * - savings
         * - autoPay
         * - contractedCost
         * - ledgerNo
         * - cost
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name           | string | like |  |
         * | address        | string | like |  |
         * | city           | string | like |  |
         * | status         | string | like |  |
         * | zipCode        | string | like |  |
         * | state          | string | eq |  |
         * | autoPay        | string | eq |  |
         * | contractedCost | number | eq |  |
         * | ledgerNo       | string | like |  |
         * | cost           | number | like |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<VectorLocationListDto, void>({
        path: `/organizations/${organizationId}/locations/vector`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VectorContracts
     * @name VectorContractsControllerGetVectorContracts
     * @request GET:/organizations/{organizationId}/vendors/{vendorId}/vector/contracts
     * @secure
     */
    vectorContractsControllerGetVectorContracts: (
      organizationId: string,
      vendorId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - locationName
         * - effectiveDate
         * - isVetted
         * - status
         * - vendorName
         * - locationName
         * - negotiationNo
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id            | string | like |  |
         * | negotiationNo | string | like |  |
         * | locationName  | string | like |  |
         * | vendorName    | string | like |  |
         * | status        | string | eq | Archived, Fully Executed, Bill Processing Only |
         * | effectiveDate | date | between |  |
         * | isVetted      | boolean | eq |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<VectorContractsListDto, void>({
        path: `/organizations/${organizationId}/vendors/${vendorId}/vector/contracts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  faqs = {
    /**
     * No description
     *
     * @tags FAQ
     * @name FaqControllerGetAllFaqs
     * @summary Get all FAQs with pagination and filtering
     * @request GET:/faqs
     * @secure
     */
    faqControllerGetAllFaqs: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - description
         * - createdAt
         * - updatedAt
         * - category
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | title       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | category    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdAt   | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | updatedAt   | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /**
         * Search term to filter FAQs by title or description
         * @example "billing"
         */
        searchTerm?: string;
        /**
         * Filter FAQs by category ID
         * @example "123e4567-e89b-12d3-a456-426614174000"
         */
        categoryId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<FaqListDto, void>({
        path: `/faqs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  deviceTokens = {
    /**
     * @description Registers or updates an FCM device token for push notifications. If the token already exists, it will be reactivated and updated.
     *
     * @tags Device Tokens
     * @name DeviceTokenControllerRegister
     * @summary Register a device token
     * @request POST:/device-tokens
     * @secure
     */
    deviceTokenControllerRegister: (
      data: RegisterDeviceTokenDto,
      params: RequestParams = {}
    ) =>
      this.request<DeviceTokenDto, void>({
        path: `/device-tokens`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device Tokens
     * @name DeviceTokenControllerGetMyTokens
     * @request GET:/device-tokens
     * @secure
     */
    deviceTokenControllerGetMyTokens: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - platform
         * - deviceName
         * - createdAt
         * - lastUsedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | platform   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | deviceName | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdAt  | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | lastUsedAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<DeviceTokensListDto, void>({
        path: `/device-tokens`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unregisters an FCM device token. Call this when the user logs out or disables notifications.
     *
     * @tags Device Tokens
     * @name DeviceTokenControllerUnregister
     * @summary Unregister a device token
     * @request DELETE:/device-tokens/{id}
     * @secure
     */
    deviceTokenControllerUnregister: (id: string, params: RequestParams = {}) =>
      this.request<UnregisterTokenDto, void>({
        path: `/device-tokens/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  review = {
    /**
     * No description
     *
     * @tags Review
     * @name ReviewControllerCreateReview
     * @request POST:/review
     * @secure
     */
    reviewControllerCreateReview: (
      data: CreateReviewDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateReviewDto, void>({
        path: `/review`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  tags = {
    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerFindAll
     * @request GET:/tags
     * @secure
     */
    tagsControllerFindAll: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         * - color
         * - createdBy
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdAt    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | updatedAt    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull |  |
         * | color        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | createdBy    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         * | isPredefined | boolean | eq, neq, isnull, isnotnull |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TagsListDto, void>({
        path: `/tags`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerCreate
     * @request POST:/tags
     * @secure
     */
    tagsControllerCreate: (data: CreateTagDto, params: RequestParams = {}) =>
      this.request<TagDto, void>({
        path: `/tags`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerFindOne
     * @request GET:/tags/{uuid}
     * @secure
     */
    tagsControllerFindOne: (uuid: string, params: RequestParams = {}) =>
      this.request<TagDto, void>({
        path: `/tags/${uuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerUpdate
     * @request PATCH:/tags/{uuid}
     * @secure
     */
    tagsControllerUpdate: (
      uuid: string,
      data: UpdateTagDto,
      params: RequestParams = {}
    ) =>
      this.request<TagDto, void>({
        path: `/tags/${uuid}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerDeleteOne
     * @request DELETE:/tags/{uuid}
     * @secure
     */
    tagsControllerDeleteOne: (uuid: string, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/tags/${uuid}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  vendors = {
    /**
     * No description
     *
     * @tags Vendors
     * @name VendorsControllerGetAllVendorsSelectList
     * @request GET:/vendors/select-list
     * @secure
     */
    vendorsControllerGetAllVendorsSelectList: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        serviceCategory?: string;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorSelectListDto, void>({
        path: `/vendors/select-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name VendorsControllerGetVendorById
     * @request GET:/vendors/{vendorId}
     * @secure
     */
    vendorsControllerGetVendorById: (
      vendorId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorDto, void>({
        path: `/vendors/${vendorId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  preference = {
    /**
     * No description
     *
     * @tags Preferences
     * @name PreferenceControllerUpsertPreferences
     * @request PUT:/preference/{key}
     * @secure
     */
    preferenceControllerUpsertPreferences: (
      key: string,
      query: {
        /** @example "user" */
        type: PreferenceControllerUpsertPreferencesParamsTypeEnum;
        organizationId?: string;
        key: string;
      },
      data: UpsertPreferenceBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<PreferenceDto, void>({
        path: `/preference/${key}`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Preferences
     * @name PreferenceControllerGetPreferences
     * @request GET:/preference
     * @secure
     */
    preferenceControllerGetPreferences: (
      query?: {
        /** @example "user" */
        type?: PreferenceControllerGetPreferencesParamsTypeEnum;
        organizationId?: string;
        key?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PreferenceListDto, void>({
        path: `/preference`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  profilePicture = {
    /**
     * No description
     *
     * @tags ProfilePicture
     * @name ProfilePictureControllerUpdateTicket
     * @request PUT:/profile-picture
     * @secure
     */
    profilePictureControllerUpdateTicket: (
      data: UpdateProfilePictureDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/profile-picture`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
  };
  mobile = {
    /**
     * No description
     *
     * @tags Mobile Versions
     * @name VersionsControllerGetMobileVersions
     * @request GET:/mobile/versions
     */
    versionsControllerGetMobileVersions: (params: RequestParams = {}) =>
      this.request<MobileVersionsDto, any>({
        path: `/mobile/versions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
}
